import { Moment } from 'moment';

export enum ExceptionType {
  InvalidCredentialException = 'InvalidCredentialException',
  UnauthorizedAccessException = 'UnauthorizedAccessException',
}

export interface GenericErrorResponse {
  statusCode: number;
  message: string;
  correlationErrorId: string;
}

export enum TipoSerie {
  Senior = 'SENIOR',
  Subordinada = 'SUBORDINADA',
}

export enum AmortizacaoSobre {
  Principal = 'PRINCIPAL',
  SaldoDevedor = 'SALDO_DEVEDOR',
}

export enum ModalidadeAmortizacao {
  CUSTOMIZADO = 'CUSTOMIZADO',
  SAC = 'SAC',
  PRICE = 'PRICE',
}

export enum NegociacaoSecundaria {
  Profissional = 'INVESTIDOR_PROFISSIONAL',
  Qualificado = 'INVESTIDOR_QUALIFICADO',
  SemRestricao = 'SEM_RESTRICAO',
}

export enum Correcao {
  Principal = 'PRINCIPAL',
  PrincipalJuros = 'PRINCIPAL_COM_JUROS',
}

export enum TipoTaxa {
  Fixo = 'FIXO',
  ProRata = 'PRO_RATA',
}

export enum TipoDistribuicaoPublica {
  _88 = '88',
  _400 = '160',
  _476 = '160 rito automático',
}

export enum TratamentoValor {
  Truncar = 'TRUNCAR',
  Arredondar = 'ARREDONDAR',
}

export enum TipoFundo {
  ETF = 'ETF',
  FIDC = 'FIDC',
  FII = 'FII',
  FIP = 'FIP',
  FIF = 'FIF',
  OFFSHORE = 'OFFSHORE',
  INEXISTENTE = 'INEXISTENTE',
  OUTROS = 'OUTROS',
}

export enum TratamentoFator {
  SemTratamento = 'SEM_TRATAMENTO',
}

export enum Moeda {
  BRL = 'BRL',
  USD = 'USD',
}

export enum Capitalizacao {
  Linear = 'LINEAR',
  Exponencial = 'EXPONENCIAL',
}

export enum ConvencaoJurosFixo {
  _30_360xDCP_DCT = '_30_360xDCP_DCT',
  _21_252xDCP_DCT = '_21_252xDCP_DCT',
  DCP_360 = 'DCP_360',
  DCP_365 = 'DCP_365',
  DUP_252 = 'DUP_252',
  _30_360eDCP_DCT = '_30_360eDCP_DCT',
  _21_252eDCP_DCT = '_21_252eDCP_DCT',
  Actual30_360 = 'Actual30_360',
  Actual360 = 'Actual360',
  Actual365 = 'Actual365',
  Business252 = 'Business252',
  Month_30 = 'Month_30',
  _30dc = '_30dc',
}

export enum CorrecaoJurosFixos {
  Principal = 'SOBRE_SALDO_DO_PRINCIPAL',
  Parcela = 'SOBRE_PARCELA',
}

export enum IndexadorJurosFlutuante {
  CDI = 'CDI',
  SelicOver = 'SELIC_OVER',
  MetaSelic = 'META_SELIC',
}

export enum IndexadorAtualizacaoMonetaria {
  IGPM = 'IGPM',
  IPCA = 'IPCA',
  USD = 'USD',
}

export enum IndexadorRemuneracao {
  Prefixado = 'PREFIXADO',
  CDI = 'CDI',
  Selic = 'SELIC',
  IGPM = 'IGPM',
  IPCA = 'IPCA',
  TR = 'TR',
}

export enum InicioRentabilidadeEnum {
  DATA_DE_INTEGRALIZACAO = 'DATA_DE_INTEGRALIZACAO',
  DATA_DE_EMISSAO = 'DATA_DE_EMISSAO',
}

export enum TipoProjecao {
  Anbima = 'ANBIMA',
  RepeteUltimo = 'REPETE_ULTIMO',
}

export enum PeriodicidadeCorrecao {
  Mensal = 'MENSAL',
  Anual = 'ANUAL',
  Diario = 'DIARIO',
}

export enum Convencao {
  DUP_252 = 'DUP_252',
  DCP_360 = 'DCP_360',
  DCP_365 = 'DCP_365',
}

export enum DefasagemFixingBase {
  Customizado = 'CUSTOMIZADO',
}

export enum DefasagemFixingDiario {
  Dmenos1 = 'D-1',
  Dmenos2 = 'D-2',
  Dmenos3 = 'D-3',
  Dmenos4 = 'D-4',
  Dmenos5 = 'D-5',
  Dmenos6 = 'D-6',
  Dmenos7 = 'D-7',
  Dmenos8 = 'D-8',
  Dmenos9 = 'D-9',
  Dmenos10 = 'D-10',
  Dmenos11 = 'D-11',
  Dmenos12 = 'D-12',
  Dmenos13 = 'D-13',
  Dmenos14 = 'D-14',
  Dmenos15 = 'D-15',
}

export enum DefasagemFixingMensal {
  Mmenos1 = 'M-1',
  Mmenos2 = 'M-2',
  Mmenos3 = 'M-3',
  Mmenos4 = 'M-4',
  Mmenos5 = 'M-5',
  Mmenos6 = 'M-6',
  Mmenos7 = 'M-7',
  Mmenos8 = 'M-8',
  Mmenos9 = 'M-9',
  Mmenos10 = 'M-10',
  Mmenos11 = 'M-11',
  Mmenos12 = 'M-12',
  Mmenos13 = 'M-13',
  Mmenos14 = 'M-14',
  Mmenos15 = 'M-15',
}

export enum DefasagemFixingAnual {
  Amenos1 = 'A-1',
  Amenos2 = 'A-2',
  Amenos3 = 'A-3',
  Amenos4 = 'A-4',
  Amenos5 = 'A-5',
  Amenos6 = 'A-6',
  Amenos7 = 'A-7',
  Amenos8 = 'A-8',
  Amenos9 = 'A-9',
  Amenos10 = 'A-10',
  Amenos11 = 'A-11',
  Amenos12 = 'A-12',
  Amenos13 = 'A-13',
  Amenos14 = 'A-14',
  Amenos15 = 'A-15',
}

export enum TipoProRata {
  Corrido = 'CORRIDO',
  Util = 'UTIL',
}

export enum TipoLiquidacao {
  Direta = 'DIRETA',
  Cip = 'CIP',
  Outras = 'OUTRAS',
  Fs = 'FS',
  B3 = 'B3',
}

export enum UploadDocumentCredenciado {
  Credenciado = 'AUTORIZACAO',
}

export enum UploadDocumentType {
  TermoSecuritizacao = 'TERMO_SECURITIZACAO',
  DeclaracaoInstituicaoCustodiante = 'DECLARACAO_DA_INSTITUICAO_CUSTODIANTE',
  ComunicadoInicioDistribuicao = 'COMUNICADO_INICIO_DISTRIBUICAO',
  DeclaracaoAgenteFiduciario = 'DECLARACAO_AGENTE_FIDUCIARIO_ICVM_583',
  OficioConcessaoRegistroOfertaPublica = 'OFICIO_CONCESSAO_REGISTRO_OFERTA_PUBLICA',
  ProspectoPreliminarDefinitivo = 'PROSPECTO_PRELIMINAR_OU_DEFINITIVO',
  TermoConstitutivo = 'TERMO_CONSTITUTIVO_DE_NOTA_COMERCIAL',
  CartulaEmissao = 'CARTULA_EMISSAO',
  RegulamentoFundo = 'REGULAMENTO_FUNDO',
}

export enum LaqusUserUploadDocumentType {
  BoletimSubscricao = 'BOLETIM_SUBSCRICAO',
}

export enum DebentureUploadDocumentType {
  EscrituraEmissao = 'ESCRITURA_EMISSAO',
  DeclaracaoInstituicaoCustodiante = 'DECLARACAO_DA_INSTITUICAO_CUSTODIANTE',
  ComunicadoInicioDistribuicao = 'COMUNICADO_INICIO_DISTRIBUICAO',
  DeclaracaoAgenteFiduciario = 'DECLARACAO_AGENTE_FIDUCIARIO_ICVM_583',
  OficioConcessaoRegistroOfertaPublica = 'OFICIO_CONCESSAO_REGISTRO_OFERTA_PUBLICA',
  ProspectoPreliminarDefinitivo = 'PROSPECTO_PRELIMINAR_OU_DEFINITIVO',
}

export enum NotaComercialUploadDocumentType {
  CartulaEmissao = 'CARTULA_EMISSAO',
  DeclaracaoInstituicaoCustodiante = 'DECLARACAO_DA_INSTITUICAO_CUSTODIANTE',
  ComunicadoInicioDistribuicao = 'COMUNICADO_INICIO_DISTRIBUICAO',
  DeclaracaoAgenteFiduciario = 'DECLARACAO_AGENTE_FIDUCIARIO_ICVM_583',
  OficioConcessaoRegistroOfertaPublica = 'OFICIO_CONCESSAO_REGISTRO_OFERTA_PUBLICA',
  ProspectoPreliminarDefinitivo = 'PROSPECTO_PRELIMINAR_OU_DEFINITIVO',
}

export enum ParticipanteUploadDocumentType {
  ContratoSocial = 'CONTRATO_SOCIAL',
  ComprovanteEleicao = 'COMPROVANTE_ELEICAO',
  DemonstracaoFinanceira = 'DEMONSTRACAO_FINANCEIRA',
  TermoAdesaoParticipante = 'TERMO_ADESAO_PARTICIPANTE',
  ComprovantePoderSignatario = 'COMPROVANTE_PODER_SIGNATARIO',
  AtoDeclaratorioCVM = 'ATO_DECLARATORIO_CVM',
  Procuracao = 'PROCURACAO',
  Identidade = 'IDENTIDADE',
  Outros = 'OUTROS',
}

export interface DocumentInfo {
  id?: string;
  type: string;
  file?: File;
  optional?: boolean;
  remoteFileInfo?: BaseDocumentResponse;
  dataVencimento?: string;
}

export interface DocumentDownloadInfo {
  url: string;
  fileName: string;
  extension: string;
}

export interface UploadDocumentos {
  documents: DocumentInfo[];
  documentsToDelete: DocumentInfo[];
}

export interface JurosFixo {
  dataInicioTaxa: Moment;
  taxaJurosFixoPorcentagem: number;
  tratamentoFatorJurosFixo: string;
  casasDecimaisFatorJurosFixo: number;
}

export interface JurosFixoViewModel extends JurosFixo {
  id: string;
}

export interface JurosFlutuante {
  dataInicioTaxaFlutuante?: Moment;
  indexador?: string;
  defasagemFixing?: string;
  fixingCustomizadoDataDivulgacaoTaxa?: Moment;
  fixingCustomizadoDataInicioTaxa?: Moment;
  indexadorPorcentagem?: number;
  tratamentoFatorFinalJurosFlutuantes?: string;
  casasDecimaisFatorFinalJurosFlutuantes?: number;
  tratamentoFatorIntermediarioDoIndexador?: string;
  casasDecimaisFatorIntermediarioDoIndexador?: number;
  tratamentoProdutorioFatorIntermediarioIndexador?: string;
  casasDecimaisProdutorioFatorIntermediarioIndexado?: number;
}

export interface AtualizacaoMonetaria {
  dataInicioDoIndexador?: Moment;
  indexador?: string;
  indexadorPorcentagem?: number;
  periodicidadeCorrecao?: string;
  proRata?: boolean;
  corrigePeriodoFinal?: boolean;
  defasagemFixing?: string;
  fixingCustomizadoDataDivulgacaoTaxa?: Moment;
  fixingCustomizadoDataInicioTaxa?: Moment;
  cotacaoInicial?: number;
  diaAniversario?: number;
  mesAniversario?: number;
  tipoProjecao?: string;
  capitalizacao?: string;
  convencao?: string;
  correcaoDoIndexador?: string;
  tratamentoFatorAtMonetariaIntermediario?: string;
  casasDecimaisFatorAtMonetariaIntermediario?: number;
  tratamentoFatorAtMonetariaFinal?: string;
  casasDecimaisFatorAtMonetariaFinal?: number;
}

export interface AtualizacaoMonetariaViewModel extends AtualizacaoMonetaria {
  id: string;
}

export interface CriteriosRemuneracao {
  valorNominalUnitarioEmissao?: number;
  quantidadeEmitida?: number;
  quantidadeDepositada?: number;
  volumeEmissao?: number;
  moedaEmissao?: string;
  cotacaoInicial?: number;
  dataEmissao?: Moment;
  dataVencimento?: Moment;
  convencaoJurosFixos?: string;
  dataInicioRentabilidade?: Moment;
  inicioRentabilidade?: InicioRentabilidadeEnum;
  remuneracao: Remuneracao;
  saldoDevedorRemanescente?: number;
  custodiantes: Array<Custodiante>;
  custoEmissao: CustoEmissao;
  tipoPagamento: string;
  convencaoCalendarioPagamento: string;
  periodicidadeAmortizacao: string;
  primeiraParcelaAmortizacao: Moment | null;
  periodicidadeJuros: string;
  primeiraParcelaJuros: Moment | null;
  dataLimiteIntegralizacao?: Moment;
  percentualMulta?: number;
  periodicidadeMulta?: number;
  percentualMora?: number;
  periodicidadeMora?: number;
}

export interface CriteriosRemuneracaoField {
  name: keyof Omit<CriteriosRemuneracao, 'remuneracao'>;
  value: undefined | null | string | number | Moment | Array<Custodiante>;
}

export interface CustoEmissao {
  custoTotal?: number;
  feeLaqusBruto: number;
  feeLaqusLiquido?: number;
  feeRepasse?: number;
}

export interface GarantiaSubTipoRequest {
  id: number;
}

export interface GarantiaTiposRequest {
  id: number;
  subTipos: Array<GarantiaSubTipoRequest>;
}

export interface InvestidorPrivado {
  investidorId: string;
  cpfCnpj: string;
  razaoSocial: string;
  ispbBanco: string;
  razaoSocialBanco: string;
  agenciaBanco: string;
  contaBanco: string;
  quantidade: number;
}

export interface InformacoesBancariasCustodiante {
  razaoSocialBanco: string;
  agenciaBanco: string;
  contaBanco: string;
  ispbBanco: string;
}

export enum RegistroStatus {
  EmAnalise = 'EM_ANALISE',
  Aprovado = 'APROVADO',
  Reprovado = 'REPROVADO',
  AguardandoCorrecao = 'REPROVADO_PENDENCIAS',
  Excluido = 'EXCLUIDO',
  AguardandoAprovacaoEdicao = 'AGUARDANDO_APROVACAO_EDICAO',
  AguardandoAprovacaoAditamento = 'AGUARDANDO_APROVACAO_ADITAMENTO',
}

export enum EmissaoStatus {
  NaoEmitido = 'NAO_EMITIDO',
  AguardandoLiquidacao = 'AGUARDANDO_LIQUIDACAO',
  Emitido = 'EMITIDO',
  ParcialmenteEmitido = 'PARCIALMENTE_EMITIDO',
}
export enum AditamentoStatus {
  Null,
  EmAnalise,
  Reprovado,
  Aprovado,
}

export enum InstrumentoFinanceiro {
  Cra = 'CRA',
  NotaComercial = 'NOTA_COMERCIAL',
  Debenture = 'DEBENTURE',
  CertificadoRecebiveis = 'CERTIFICADO_RECEBIVEIS',
  Cri = 'CRI',
  Cdca = 'CDCA',
  CotasDeFundo = 'COTAS_FUNDO',
}

export interface RascunhoApiResponse {
  id: string;
  originId: string;
  userId: string;
  createDate: Moment;
  updateDate: Moment;
}

export interface InstrumentoFinanceiroApiResponse {
  aditado: boolean;
  id: number;
  instrumentoFinanceiroGuid: string;
  draft?: RascunhoApiResponse;
  emissorId?: string;
  razaoSocialEmissor: string;
  codigo: string;
  codigoExterno: string;
  ticket: string;
  status: RegistroStatus;
  statusEmissao: EmissaoStatus;
  suspenso: boolean;
  encerrado?: boolean;
  dataDeCriacao: Date;
  dataUltimaAlteracao: Date;
  dataDeAprovacao?: Date;
  tipoInstrumentoFinanceiro: InstrumentoFinanceiro;
  numeroEmissao: string;
  numeroSerie: string;
  tipoSerie?: TipoSerie;
  regimeFiduciario: boolean;
  distribuicaoPublica: boolean;
  negociacaoSecundariaPor: string;
  depositariaEmissao: string;
  utilizacaoAnuncioInicioDistribuicao?: boolean;
  ufLocalEmissao: string;
  localEmissao: string;
  classificadoraRisco1?: string;
  rating1?: string;
  classificadoraRisco2?: string;
  rating2?: string;
  ufLocalPagamento: string;
  localPagamento: string;
  razaoSocialInstituicaoCustodiante: string;
  cnpjInstituicaoCustodiante: string;
  utilizacaoFaculdadeParagrafo3Art7: boolean;
  nomeResponsavelPelasInformacoesDRI: string;
  emailResponsavelPelasInformacoesDRI: string;
  bancoLiquidanteEmissor: string;
  cnpjBancoLiquidanteEmissor: string;
  codigoBancoContaCorrenteVinculadaEmissao: string;
  numeroAgenciaContaCorrenteVinculadaEmissao: string;
  numeroContaCorrenteVinculadaEmissao: string;
  tipoLiquidacao: string;
  descricaoAdicional?: string;
  chaveExterna: string;
  isin: string;
  coobrigacao?: boolean;
  naturezaAgenteFiduciario?: string;
  razaoSocialAgenteFiduciario?: string;
  cpfCnpjAgenteFiduciario?: string;
  tipoDistribuicaoPublica?: string;
  contraparteRecebedora?: string;
  dataEncerramentoDistribuicao?: Moment;
  coordenadores: Array<CoordenadorResponse>;
  coordenadorLider?: ParticipanteResponse;
  razaoSocialEscriturador?: string;
  cnpjEscriturador?: string;
  garantias?: Array<GarantiaTipoResponse>;
  descricaoAdicionalGarantias?: string;
  custodiantes?: Array<Custodiante>;
  criteriosRemuneracao: GETCriteriosRemuneracao;
  custoEmissao: GETCustoEmissao;
  garantiaInstrumentoFinanceiro?: GETGarantiaInstrumentoFinanceiro | null;
  amortizacaoSobre: AmortizacaoSobre;
  amortizacaoPassivelAoTermoSecuritizacao: boolean;
  amortizacoes: Amortizacao[];
  pagamentoJuros: PagamentoJuros;
  incorporacaoJuros: IncorporacaoJuros;
  possuiResgateAntecipado: boolean;
  vasosComunicantes?: boolean;
  modalidadeAmortizacao?: ModalidadeAmortizacao;
  documents: Document[];
  registro: RegistroResponse;
  emissor?: ParticipanteResponse;
  hasPagamentosInadimplentes: boolean;
  canSolicitarLiquidacao?: boolean;
  integracaoMonitor?: IntegracaoMonitorResponse;
  funcaoSolicitante?: FuncaoParticipante | FuncaoInternaParticipante;
  origem?: string;
  statusValidacao?: string;
  ofertaPrimariaInvestidores?: OfertaPrimariaInvestidorResponse[];
  puDiario?: number;
}

export interface CoordenadorResponse {
  participante: ParticipanteResponse;
  valor: number;
  tipoDelimitacao: 'VALOR' | 'QUANTIDADE';
  instrumentoFinanceiroId: number;
  id: string;
  cnpj: string;
  razaoSocial: string;
}

export interface CraApiResponse extends InstrumentoFinanceiroApiResponse {
  craId: string;
  termoSecuritizacaoFormalizado: boolean;
  codigoCvmCiaSecuritizadora: string;
  averbadoEmCartorio: boolean;
  registroNaInstituicaoCustodiante: boolean;
  garantiaFlutuante: boolean;
  tipoGarantia: string;
  ativoGarantia: string;
  valorGarantia: number;
  nomeGarantidor: string;
  cpfCnpjGarantidor: string;
  naturezaGarantidor: string;
  cnpjEmissor: string;
}

export interface CdcaApiResponse extends InstrumentoFinanceiroApiResponse {
  cdcaId: string;
  termoSecuritizacaoFormalizado: boolean;
  codigoCvmCiaSecuritizadora: string;
  averbadoEmCartorio: boolean;
  registroNaInstituicaoCustodiante: boolean;
  garantiaFlutuante: boolean;
  tipoGarantia: string;
  ativoGarantia: string;
  valorGarantia: number;
  nomeGarantidor: string;
  cpfCnpjGarantidor: string;
  naturezaGarantidor: string;
  cnpjEmissor: string;
}

export interface CotasDeFundoApiResponse extends InstrumentoFinanceiroApiResponse {
  cotasDeFundoId: string;
  emissor: ParticipanteResponse;
  emissorId?: string;
  administradorFiduciarioId?: string;
  administradorFiduciario?: string;
  nomeFantasia?: string;
  gestor?: string;
  escriturador?: string;
  escrituradorId?: string;
  custodiante?: string;
  custodianteId?: string;
  codigoAtivo?: string;
  cnpjFundo: string;
  classe?: string;
  serie?: string;
  classificacaoANBIMA?: string;
  codigoANBIMA?: string;
  numeroAutorizacaoCVM?: number;
  dataAutorizacaoCVM?: Date | string | number;
  fundoExclusivo?: boolean;
  carencia?: number;
  tipoFundo?: string;
  casasDecimaisConversao?: number;
  criterioEspecificacaoCotas?: string;
  especificacaoQuantidadeAutomatica?: boolean;
  custoCotista?: string;
  confirmacaoOperacao?: string;
  prazoCotacaoAplicacao?: number;
  prazoCotacaoResgate?: number;
  prazoLiquidacaoResgate?: number;
  responsavelClassificacaoFundo?: string;
  temPrevisaoPenalty?: boolean;
  percentualPenalty?: number;
  descricaoFundo?: string;
  codigoExterno: string;
}

export interface CriApiResponse extends InstrumentoFinanceiroApiResponse {
  criId: string;
  termoSecuritizacaoFormalizado: boolean;
  codigoCvmCiaSecuritizadora: string;
  averbadoEmCartorio: boolean;
  registroNaInstituicaoCustodiante: boolean;
  garantiaFlutuante: boolean;
  tipoGarantia: string;
  ativoGarantia: string;
  valorGarantia: number;
  nomeGarantidor: string;
  cpfCnpjGarantidor: string;
  naturezaGarantidor: string;
  cnpjEmissor: string;
}

export interface DebentureApiResponse extends InstrumentoFinanceiroApiResponse {
  debentureId: string;
  escrituraEmissaoFormalizado: boolean;
  cnpjEmissor: string;
}

export interface NotaComercialApiResponse extends InstrumentoFinanceiroApiResponse {
  notaComercialId: string;
  cartulaEmissaoFormalizado: boolean;
}

export interface CertificadoRecebiveisApiResponse extends InstrumentoFinanceiroApiResponse {
  certificadoRecebiveisId: string;
  termoSecuritizacaoFormalizado: boolean;
  codigoCvmCiaSecuritizadora?: string | null;
  averbadoEmCartorio: boolean;
  registroNaInstituicaoCustodiante: boolean;
  garantiaFlutuante: boolean;
  tipoGarantia?: string | null;
  ativoGarantia?: string | null;
  valorGarantia: number;
  nomeGarantidor?: string | null;
  cpfCnpjGarantidor?: string | null;
  naturezaGarantidor?: string | null;
  cnpjEmissor: string;
}

export interface CadastroInstrumentoFinanceiroApiRequest {
  draftId?: string;
  emissorId?: string;
  codigoExterno?: string;
  codigo?: string;
  numeroEmissao: string;
  numeroSerie: string;
  tipoSerie?: TipoSerie;
  regimeFiduciario: boolean;
  distribuicaoPublica: boolean;
  negociacaoSecundariaPor: NegociacaoSecundaria;
  depositariaEmissao: string;
  utilizacaoAnuncioInicioDistribuicao?: boolean;
  ufLocalEmissao: string;
  localEmissao: string;
  classificadoraRisco1?: string;
  rating1?: string;
  classificadoraRisco2?: string;
  rating2?: string;
  ufLocalPagamento: string;
  localPagamento: string;
  custodiantes: Array<Custodiante>;
  utilizacaoFaculdadeParagrafo3Art7: boolean;
  nomeResponsavelPelasInformacoesDRI: string;
  emailResponsavelPelasInformacoesDRI: string;
  bancoLiquidanteEmissor: string;
  cnpjBancoLiquidanteEmissor: string;
  codigoBancoContaCorrenteVinculadaEmissao: string;
  numeroAgenciaContaCorrenteVinculadaEmissao: string;
  numeroContaCorrenteVinculadaEmissao: string;
  tipoLiquidacao: string;
  descricaoAdicional: string;
  chaveExterna: string;
  isin: string;
  coobrigacao?: boolean;
  naturezaAgenteFiduciario: string;
  razaoSocialAgenteFiduciario: string;
  cpfCnpjAgenteFiduciario: string;
  tipoDistribuicaoPublica: string;
  contraparteRecebedora: string;
  dataEncerramentoDistribuicao?: string;
  coordenadoresIds: Array<string>;
  coordenadorLiderId?: string;
  razaoSocialEscriturador: string;
  cnpjEscriturador: string;
  cnpjEmissor?: string;
  garantias?: Array<GarantiaTiposRequest>;
  descricaoAdicionalGarantias?: string;
  criteriosRemuneracao: {
    valorNominalUnitarioEmissao?: number;
    quantidadeEmitida?: number;
    quantidadeDepositada?: number;
    volumeEmissao?: number;
    moedaEmissao?: string;
    dataEmissao?: string;
    dataVencimento?: string;
    dataLimiteIntegralizacao?: string;
    cotacaoInicial?: number;
    dataInicioRentabilidade?: string;
    inicioRentabilidade?: InicioRentabilidadeEnum;
    indexador?: IndexadorRemuneracao;
    indexadorPorcentagem?: number;
    defasagemFixing?: DefasagemFixingType;
    periodicidadeCorrecao?: PeriodicidadeCorrecao;
    proRata?: TipoProRata;
    corrigePeriodoFinal?: boolean;
    diaAniversario?: number;
    mesAniversario?: number;
    tipoProjecao?: TipoProjecao;
    taxaJurosFixoSpread?: number;
    convencaoJurosFixos?: ConvencaoJurosFixo;
    custoEmissao: CustoEmissao;
    percentualMulta?: number;
    periodicidadeMulta?: number;
    percentualMora?: number;
    periodicidadeMora?: number;
  };
  amortizacaoSobre: AmortizacaoSobre;
  amortizacaoPassivelAoTermoSecuritizacao?: boolean;
  modalidadeAmortizacao?: ModalidadeAmortizacao;
  amortizacoes: Amortizacao[];
  pagamentoJuros: {
    datas: string[];
  };
  incorporacaoJuros: {
    datas: string[];
  };
  possuiResgateAntecipado: boolean;
  vasosComunicantes?: boolean;
  tipoPagamento?: string;
  convencaoCalendarioPagamento?: string;
  primeiraParcelaAmortizacao?: string;
  primeiraParcelaJuros?: string;
  periodicidadeAmortizacao?: string;
  periodicidadeJuros?: string;
  documents: Array<DocumentRequest>;
}

export interface Custodiante {
  custodianteId: string;
  razaoSocialInstituicaoCustodiante: string;
  cnpjInstituicaoCustodiante: string;
  investidoresPrivados: Array<InvestidorPrivado>;
  informacoesBancarias: Array<InformacoesBancariasCustodiante>;
}

export interface CadastroCraApiRequest extends CadastroInstrumentoFinanceiroApiRequest {
  termoSecuritizacaoFormalizado: boolean;
  codigoCvmCiaSecuritizadora: string;
  averbadoEmCartorio: boolean;
  registroNaInstituicaoCustodiante: boolean;
  garantiaFlutuante: boolean;
  tipoGarantia: string;
  ativoGarantia: string;
  valorGarantia: number;
  nomeGarantidor: string;
  cpfCnpjGarantidor: string;
  naturezaGarantidor: string;
}

export interface CadastroCdcaApiRequest extends CadastroInstrumentoFinanceiroApiRequest {
  termoSecuritizacaoFormalizado: boolean;
  codigoCvmCiaSecuritizadora: string;
  averbadoEmCartorio: boolean;
  registroNaInstituicaoCustodiante: boolean;
  garantiaFlutuante: boolean;
  tipoGarantia: string;
  ativoGarantia: string;
  valorGarantia: number;
  nomeGarantidor: string;
  cpfCnpjGarantidor: string;
  naturezaGarantidor: string;
}

export interface CadastroCotasDeFundoApiRequest extends CadastroInstrumentoFinanceiroApiRequest {
  emissor: string;
  emissorId: string;
  administradorFiduciarioId: string;
  nomeFantasia: string;
  gestor: string;
  escrituradorId: string;
  custodianteId: string;
  codigoAtivo: string;
  cnpjFundo: string;
  classe: string;
  serie: string;
  isin: string;
  classificacaoAnbima: string;
  codigoAnbima: string;
  numeroAutorizacaoCvm: number;
  dataAutorizacaoCvm: number;
  fundoExclusivo: boolean;
  carencia: number;
  tipoFundo: string;
  casasDecimaisConversao: number;
  criterioEspecificacaoCotas: string;
  especificacaoQuantidadeAutomatica: boolean;
  custoCotista: string;
  confirmacaoOperacao: string;
  prazoCotacaoAplicacao: number;
  prazoCotacaoResgate: number;
  prazoLiquidacaoResgate: number;
  responsavelClassificacaoFundo: string;
  temPrevisaoPenalty: boolean;
  percentualPenalty: number;
  descricaoFundo: string;
}

export interface CadastroCriApiRequest extends CadastroInstrumentoFinanceiroApiRequest {
  termoSecuritizacaoFormalizado: boolean;
  codigoCvmCiaSecuritizadora: string;
  averbadoEmCartorio: boolean;
  registroNaInstituicaoCustodiante: boolean;
  garantiaFlutuante: boolean;
  tipoGarantia: string;
  ativoGarantia: string;
  valorGarantia: number;
  nomeGarantidor: string;
  cpfCnpjGarantidor: string;
  naturezaGarantidor: string;
}

export interface CadastroDebentureApiRequest extends CadastroInstrumentoFinanceiroApiRequest {
  escrituraEmissaoFormalizado: boolean;
}

export interface CadastroNotaComercialApiRequest extends CadastroInstrumentoFinanceiroApiRequest {
  cartulaEmissaoFormalizado: boolean;
}

export interface CadastroNCByFile {
  diretorio: string;
  nomeArquivo: string;
  arquivo: string;
}

export interface GETNotasComerciaisByFileParams {
  diretorio?: string | null;
  bucket: string;
}

export interface GETFileNotaComercialByFileParams {
  diretorio: string;
  nomeArquivo: string;
  bucket: string;
}

export interface CadastroCertificadoRecebiveisApiRequest extends CadastroInstrumentoFinanceiroApiRequest {
  termoSecuritizacaoFormalizado: boolean;
  codigoCvmCiaSecuritizadora: string;
  averbadoEmCartorio: boolean;
  registroNaInstituicaoCustodiante: boolean;
  garantiaFlutuante: boolean;
  tipoGarantia: string;
  ativoGarantia: string;
  valorGarantia: number;
  nomeGarantidor: string;
  cpfCnpjGarantidor: string;
  naturezaGarantidor: string;
}

export interface GETCriteriosRemuneracao {
  valorNominalUnitarioEmissao: number;
  quantidadeEmitida: number;
  quantidadeDepositada: number;
  quantidadeRestante: number;
  volumeEmissao: number;
  moedaEmissao: string;
  dataEmissao: Moment;
  dataVencimento: Moment;
  cotacaoInicial?: number;
  dataInicioRentabilidade?: Moment;
  indexador: IndexadorRemuneracao;
  indexadorPorcentagem: number;
  defasagemFixing?: DefasagemFixingType;
  periodicidadeCorrecao?: PeriodicidadeCorrecao;
  proRata?: TipoProRata;
  corrigePeriodoFinal?: boolean;
  diaAniversario?: number;
  mesAniversario?: number;
  tipoProjecao?: TipoProjecao;
  taxaJurosFixoSpread: number;
  convencaoJurosFixos?: ConvencaoJurosFixo;
  saldoDevedorRemanescente: number;
  liquidacaoDireta?: boolean;
  precoUnitarioLiquidacao: number;
  percentualAmortizacaoRemanescente: number;
  investidoresPrivados: Array<InvestidorPrivado>;
  puAtualizado?: number;
  puAtualizadoEm?: Date;
  custoEmissao: GETCustoEmissao;
  inicioRentabilidade: InicioRentabilidadeEnum;
  dataLimiteIntegralizacao?: string;
  historicoLancamentoPUs?: Array<HistoricoLancamentoPU>;
  percentualMulta?: number;
  periodicidadeMulta?: number;
  percentualMora?: number;
  periodicidadeMora?: number;
}

export interface HistoricoLancamentoPU {
  valor: number;
  data: string;
}

export interface HistoricoAtualizacaoCota {
  id: string;
  cotaDeFundoId: string;
  dataReferencia: string;
  valorCota: number;
  patrimonioLiquido: number;
  rentabilidadeDia: number;
  rentabilidadeMes: number;
  rentabilidadeAno: number;
}

export interface GETCustoEmissao {
  custoTotal?: number;
  feeLaqusBruto: number;
  feeLaqusLiquido?: number;
  feeRepasse?: number;
}
export interface GarantiaSubTipoResponse {
  id: number;
  nome: string;
}
export interface GarantiaTipoResponse {
  id: number;
  nome: string;
  subTipos: Array<GarantiaSubTipoResponse>;
}
export interface GarantiasResponse {
  garantias: Array<GarantiaTipoResponse>;
}

export interface GETGarantiaInstrumentoFinanceiro {
  instrumentoFinanceiroId: number;
  garantiaSubTipoId: number;
}

export interface PagamentoAmortizacao {
  porcentagem: number;
  data: Moment;
}

export interface PagamentoJuros {
  datas: Moment[];
}

export interface IncorporacaoJuros {
  datas: Moment[];
}

export type DefasagemFixingType =
  | typeof DefasagemFixingBase
  | typeof DefasagemFixingDiario
  | typeof DefasagemFixingMensal
  | typeof DefasagemFixingAnual;

export interface Remuneracao {
  indexador?: IndexadorRemuneracao;
  defasagemFixing?: DefasagemFixingType;
  indexadorPorcentagem?: number;
  periodicidadeCorrecao?: PeriodicidadeCorrecao;
  proRata?: TipoProRata;
  corrigePeriodoFinal?: boolean;
  diaAniversario?: number;
  mesAniversario?: number;
  tipoProjecao?: TipoProjecao;
  taxaJurosFixoSpreadPorcentagem?: number;
  convencao?: ConvencaoJurosFixo;
}

export interface DocumentRequest {
  id?: string;
  emissionType: string;
  address: string;
  fileName: string;
  extension: string;
  size: number;
}

export interface BaseDocumentResponse {
  id: string;
  address: string;
  fileName: string;
  extension: string;
  size: number;
  creationDate: Date;
  dataVencimento?: string;
}

export interface Document extends BaseDocumentResponse {
  emissionType: UploadDocumentType;
}

export type RascunhoRequest =
  | CadastroCraApiRequest
  | CadastroCdcaApiRequest
  | CadastroCotasDeFundoApiRequest
  | CadastroCriApiRequest
  | CadastroDebentureApiRequest
  | CadastroNotaComercialApiRequest
  | CadastroCertificadoRecebiveisApiRequest;

export interface RascunhoDocumentRequest {
  emissionType: string;
  file: File;
}

export interface RascunhoIdAndCod {
  draftId: string;
  codigo: string;
}

export enum PercentualAmortizacao {
  Principal = 'PRINCIPAL',
  SaldoDevedor = 'SALDO_DEVEDOR',
}

export interface Amortizacao {
  percentualAmortizacao?: number;
  dataAmortizacao?: Moment;
}

export interface AmortizacaoDataGrid {
  id: string;
  percentualAmortizacao?: number;
  dataAmortizacao?: Moment;
  isNew?: boolean;
}

export enum Liquidacao {
  Dmenos2 = 'D-2',
  Dmenos1 = 'D-1',
  Dzero = 'D-0',
  Dmais1 = 'D+1',
  Dmais2 = 'D+2',
}

export interface DateViewModel {
  id: string;
  date: Moment;
}

export interface AmortizacaoViewModel extends Amortizacao {
  id: string;
}

export enum DepositariaEmissao {
  Laqus = 'laqus',
  B3 = 'b3',
  Outros = 'outros',
}

export enum RegistroOcorrenciaResponse {
  ParaAnalise = 'PARA_ANALISE',
  Aprovado = 'APROVADO',
  Reprovado = 'REPROVADO',
  ReprovadoPendencias = 'REPROVADO_PENDENCIAS',
  Suspenso = 'SUSPENSO',
  SuspensaoRevogada = 'SUSPENSAO_REVOGADA',
}

export interface RegistroHistoricoResponse {
  id: string;
  registroId: string;
  dataDeCriacao: Date;
  justificativa?: string;
  registroOcorrencia: RegistroOcorrenciaResponse;
  registroHistoricoDocuments?: Array<BaseDocumentResponse>;
  kyc?: KnowYourCustomerResponse;
}

export interface RegistroResponse {
  id: string;
  ticket: string;
  dataDeCriacao: Date;
  status: RegistroStatus;
  suspenso: boolean;
  registroHistoricos?: Array<RegistroHistoricoResponse>;
  solicitanteId?: string;
  solicitanteName?: string;
  solicitanteParticipanteName?: string;
}

export interface CadastroParticipanteRequest {
  tipoAcesso: string;
  funcoes: Array<{ funcao: FuncaoParticipante }>;
  razaoSocial: string;
  cnpj: string;
  cep: string;
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  uf: string;
  telefones: Array<string>;
  atividadePrincipalDesenvolvida: string;
  faturamentoMedioMensalUltimosDozeMeses: number;
  razaoSocialBancoLiquidante: string;
  ispbBancoLiquidante: string;
  agenciaBancoLiquidante: string;
  contaBancoLiquidante: string;
  inscricaoEstadual: string;
  inscricaoMunicipal: string;
  grupoEconomico: string;
  representantesLegais: Array<RepresentanteLegal>;
  usuarios: Array<UsuarioParticipante>;
}

export interface CadastroUsuarioRequest {
  nome: string;
  senha: string;
  cpf: string;
}

export interface AnbimaTokenResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
}

export interface AnbimaPrestadorFundo {
  codigo_tipo_prestador: string;
  identificador: string;
  razao_social: string;
  nome_comercial: string;
  tipo_pessoa: string;
  codigo_pais: string;
  data_inicio_vigencia: string;
  data_fim_vigencia: string | null;
  data_atualizacao: string;
}

export interface AnbimaPerfilComplementar {
  codigo_b3: string | null;
  restricao_investimento: string;
  tipo_investidor: string;
  aplicacao_automatica: string;
  plano_previdencia: string;
  periodicidade_envio_pl_cota: string;
  calculo_cota: string;
  data_atualizacao: string;
}

export interface AnbimaValoresMinimosMovimentacaoClasse {
  data_vigencia: string;
  indicador_prazo_emissao_cota: string | null;
  prazo_emissao_cota: number;
  indicador_prazo_conversao_resgate: string | null;
  prazo_conversao_resgate: number;
  indicador_prazo_pagamento_resgate: string | null;
  prazo_pagamento_resgate: number;
  regra_adicional_pagamento_resgate: string;
  dias_carencia_inicial: string | null;
  dias_carencia_ciclica: number;
  valor_minimo_aplicacao_inicial: number;
  valor_minimo_aplicacao_subsequente: number;
  valor_minimo_resgate: number;
  valor_minimo_permanencia: number;
  data_atualizacao: string;
}

export interface AnbimaIndiceBenchmark {
  benchmark: string;
  data_inicio_vigencia: string;
  data_fim_vigencia: string | null;
  data_atualizacao: string;
}

export interface AnbimaClasse {
  codigo_classe: string;
  tipo_identificador_classe: string;
  identificador_classe: string;
  data_inicio_atividade_classe: string;
  razao_social_classe: string;
  nome_comercial_classe: string;
  tributacao_perseguida: string;
  alavancado: string;
  credito_privado: string;
  percentual_permitido_credito_privado: number;
  investimento_exterior: string;
  percentual_permitido_investimento_exterior: number;
  foco_atuacao: string;
  fundo_esg: string;
  forma_condominio: string;
  entidade_investimento_fins_tributarios: string;
  infraestrutura: string;
  responsabilidade_limitada: string;
  categoria_cvm: string;
  composicao: string;
  tipo_anbima: string;
  nivel1_categoria: string;
  nivel2_categoria: string;
  nivel3_subcategoria: string;
  data_encerramento_classe: string | null;
  data_vigencia_classe: string;
  taxas_classe: any | null;
  prestadores_classe: any | null;
  perfil_complementar: AnbimaPerfilComplementar;
  taxas_entrada_saida_classe: any | null;
  valores_minimos_movimentacao_classe: AnbimaValoresMinimosMovimentacaoClasse;
  indices_benchmark: Array<AnbimaIndiceBenchmark>;
  subclasses: any | null;
  taxa_performance: any | null;
  data_atualizacao: string;
  '95_por_cento_fundo_isento': string;
}

export interface AnbimaFundoResponse {
  codigo_fundo: string;
  tipo_identificador_fundo: string;
  identificador_fundo: string;
  tipo_fundo: string;
  razao_social_fundo: string;
  nome_comercial_fundo: string;
  adaptado_rcvm175: string;
  moeda: string;
  atributo: string;
  data_encerramento_fundo: string | null;
  documentos: any | null;
  prestadores_fundo: Array<AnbimaPrestadorFundo>;
  data_vigencia_fundo: string;
  classes: Array<AnbimaClasse>;
  data_atualizacao: string;
}

export interface FundoInvestidorRequest {
  nomeFantasia: string;
  cnpjFundo: string;
  razaoSocialAdministrador: string;
  cnpjAdministrador: string;
  razaoSocialGestor: string;
  cnpjGestor: string;
  escrituradorId: string;
  nomeSimplificadoEscriturador: string;
  cnpjEscriturador: string;
  custodianteId: string;
  razaoSocialCustodiante: string;
  cnpjCustodiante: string;
  razaoSocialBancoLiquidante: string;
  cnpjBancoLiquidante: string;
  agencia: string;
  contaMovimento: string;
  codigoAtivo: string;
  classe: string;
  classificacaoANBIMA: string;
  codigoANBIMA: string;
  fundoExclusivo: boolean | string;
  tipoFundo: TipoFundo | string;
}

export interface FundoInvestidorResponse {
  id: string;
  investidorId: string;
  nomeFantasia: string;
  cnpjFundo: string;
  administradorId: string;
  razaoSocialAdministrador: string;
  cnpjAdministrador: string;
  gestorId: string;
  razaoSocialGestor: string;
  cnpjGestor: string;
  escrituradorId: string;
  nomeSimplificadoEscriturador: string;
  cnpjEscriturador: string;
  custodianteId: string;
  razaoSocialCustodiante: string;
  cnpjCustodiante: string;
  razaoSocialBancoLiquidante: string;
  cnpjBancoLiquidante: string;
  ispbBancoLiquidante: string;
  agencia: string;
  contaMovimento: string;
  codigoAtivo: string;
  classe: string;
  classificacaoANBIMA: string;
  codigoANBIMA: string;
  fundoExclusivo: boolean;
  tipoFundo: TipoFundo;
}

export interface InvestidorFundoResponse {
  id: string;
  fundoInvestidor: FundoInvestidorResponse;
  [key: string]: any;
}

export enum TipoRepresentanteLegal {
  Controlador = 'CONTROLADOR',
  Administrador = 'ADMINISTRADOR',
  Procurador = 'PROCURADOR',
  RepresentanteLegal = 'REPRESENTANTE_LEGAL',
}

export enum TipoCargo {
  C_Level = 'C_LEVEL',
  Gerente = 'GERENTE',
  Coordenador = 'COORDENADOR',
  Analista = 'ANALISTA',
  SegurancaInformacao = 'SEGURANCA_INFORMACAO',
  Juridico = 'JURIDICO',
  RepresentanteLegal = 'REPRESENTANTE_LEGAL',
}

export interface ParticipanteFuncaoResponse {
  participanteFuncaoId?: string;
  funcao: FuncaoParticipante;
}

export interface CodigoInstumentoResponse {
  codigo: string;
}

export interface ParticipanteResponse {
  id: string;
  ticket: string;
  dataCriacao: Moment;
  tipoAcesso: TipoAcessoParticipante;
  funcoes: Array<ParticipanteFuncaoResponse>;
  cnpj: string;
  razaoSocial: string;
  cep: string;
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  uf: string;
  telefones: Array<string>;
  atividadePrincipalDesenvolvida: string;
  faturamentoMedioMensalUltimosDozeMeses: number;
  razaoSocialBancoLiquidante: string;
  ispbBancoLiquidante: string;
  agenciaBancoLiquidante: string;
  contaBancoLiquidante: string;
  inscricaoEstadual?: string;
  inscricaoMunicipal?: string;
  grupoEconomico?: string;
  representantesLegais: Array<RepresentanteLegal>;
  documentos: Array<ParticipanteDocumentResponse>;
  registro: RegistroResponse;
  codigo?: string;
  suspenso?: boolean;
  usuarios: Array<UsuarioParticipante>;
  avaliadoPeloKyc?: boolean;
}

export interface UsuarioParticipante {
  nome: string;
  cpf: string;
  email: string;
  perfil: Perfil;
  tipo?: TipoCargo;
  conviteAceito?: boolean;
}

export interface UsuarioParticipanteApiResponse extends UsuarioParticipante {
  id: string;
  suspenso: boolean;
}

export interface UsuarioModelResponse {
  id: string;
  nome: string;
  cpf: string;
  email: string;
  dataDeCriacao: Moment;
  ativo: boolean;
  suspenso: boolean;
  grupoAcesso: GrupoAcesso;
  participanteFuncoes: Array<ParticipanteFuncaoUsuarioResponse>;
  modulos?: Array<ModuloUsuarioResponse>;
}

export interface UsuarioEditRequest {
  id: string;
  nome: string;
  ativo: boolean;
  grupoAcesso: GrupoAcesso;
  funcaoParticipanteUsuarios: Array<{
    participanteFuncaoId: string;
    perfil: Perfil;
    moduloUsuario: Array<ModuloUsuarioRequest>;
  }>;
}

export interface ParticipanteFuncaoUsuarioResponse {
  participanteFuncaoId: string;
  participanteId: string;
  razaoSocialParticipante: string;
  cnpjParticipante: string;
  funcao: FuncaoParticipante | FuncaoInternaParticipante;
  perfil: Perfil;
  dataInicioVigencia: Moment;
  dataFimVigencia: Moment;
}

export interface ParticipanteDocumentResponse extends BaseDocumentResponse {
  participanteDocumentType: ParticipanteUploadDocumentType;
}

export interface ConviteResponse {
  id: string;
  ativo?: boolean;
  dataDeCriacao: Date;
  email: string;
  nome: string;
  cpf: string;
  tipo?: number;
  grupoAcesso?: GrupoAcesso;
  funcaoModulos: Array<FuncaoPerfilModulosRequest>;
  registroId?: string;
  participanteId?: string;
}

export interface ConviteDataResponse {
  usuario: UsuarioResponse;
  convite: Array<ConviteResponse>;
}

export interface ConviteRequest {
  email: string;
  nome: string;
  cpfCnpj: string;
  perfil: Perfil;
  moduloUsuario?: Array<ModuloUsuarioRequest>;
}

export interface ConviteUsuarioRequest {
  email: string;
  nome: string;
  participanteId: string;
  grupoAcesso: GrupoAcesso;
  funcaoModulos: Array<FuncaoPerfilModulosRequest>;
  documento?: File;
}

export interface FuncaoPerfilModulosRequest {
  funcao: FuncaoParticipante | FuncaoInternaParticipante;
  perfil: Perfil;
  modulosUsuario: Array<ModuloUsuarioRequest>;
}

export interface ModuloUsuarioRequest {
  id: number;
  habilitado?: boolean;
}

export interface ConviteModelRequest extends ConviteRequest {
  participanteId: string;
  grupoAcesso: GrupoAcesso;
}

export interface UsuarioResponse {
  id: string;
  nome: string;
  email: string;
  participanteId?: string;
  cpf?: string;
  suspenso?: boolean;
  tipo?: number;
  ativo?: boolean;
  excluido?: boolean;
}

export enum TipoAcessoParticipante {
  Participante = 'PARTICIPANTE',
  Depositaria = 'DEPOSITARIA',
}

export enum CategoriaParticipante {
  Emissor = 'EMISSOR',
  Custodiante = 'CUSTODIANTE',
  Escriturador = 'ESCRITURADOR',
  Credenciado = 'CREDENCIADO',
}

export enum FuncaoParticipante {
  AgenteFiduciario = 'AGENTE_FIDUCIARIO',
  Coordenador = 'COORDENADOR',
  Credenciado = 'CREDENCIADO',
  Custodiante = 'CUSTODIANTE',
  Emissor = 'EMISSOR',
  Escriturador = 'ESCRITURADOR',
  AdministradorFiduciario = 'ADMINISTRADOR_FIDUCIARIO',
}

export enum FuncaoInternaParticipante {
  Depositaria = 'DEPOSITARIA',
}

export interface FuncaoRequest {
  funcoes: Array<FuncaoParticipante | FuncaoInternaParticipante>;
  habilitado: boolean;
}

export enum CategoriaParticipanteInterno {
  CoordenadorLider = 'COORDENADOR_LIDER',
}

export enum Perfil {
  Master = 'MASTER',
  Escrita = 'ESCRITA',
  Leitura = 'LEITURA',
}

export interface RouterState {
  from: { pathname: string };
}

export interface LoginResponse {
  id: string;
  nome: string;
  email: string;
  dataCriacao: Moment;
  token: string;
  grupoAcesso: GrupoAcesso;
  participante: {
    id: string;
    razaoSocial: string;
    cnpj: string;
    dataCriacao: Moment;
    tipoAcesso: TipoAcessoParticipante;
    funcao: FuncaoParticipante | FuncaoInternaParticipante;
    perfil: Perfil;
  };
  modulos: Array<ModuloUsuarioResponse>;
}

export interface RepresentanteLegalBase {
  nome: string;
  cpf: string;
}

export interface RepresentanteLegal extends RepresentanteLegalBase {
  id: string;
  email?: string;
  tipo: TipoRepresentanteLegal;
  cargo?: string;
  telefone?: string;
  outorgaTotal?: boolean;
  dataExpiracao?: Date;
}

export interface RepresentanteLegalRequest extends RepresentanteLegalBase {
  tipo: TipoRepresentanteLegal;
}

export interface Endereco {
  cep: string;
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  uf: string;
}

export interface GETParticipanteFilterParams {
  cnpj?: string;
  status?: RegistroStatus;
  funcao?: FuncaoParticipante;
  funcoes?: Array<FuncaoParticipante>;
  suspenso?: boolean;
  page?: number;
  pageSize?: number;
}

export interface ParticipantesFilter {
  columnType?: string;
  operationFilterType?: string;
  orderByType?: string;
  value?: string;
}

export interface POSTParticipanteFilterParams {
  page?: number;
  pageSize?: number;
  linkOperator?: string;
  FilterTypeParticipante?: Array<ParticipantesFilter>;
}

export enum InvestidorDocumentType {
  IdentidadeInvestidor = 'IDENTIDADE_INVESTIDOR',
  ContratoSocial = 'CONTRATO_SOCIAL',
  ComprovanteEndereco = 'COMPROVANTE_ENDERECO',
  ComprovanteRenda = 'COMPROVANTE_RENDA',
  IdentidadeRepresentanteLegalProcurador = 'IDENTIDADE_REPRESENTANTE_LEGAL_PROCURADOR',
  Procuracao = 'PROCURACAO',
}

export interface InvestidorDocuments extends BaseDocumentResponse {
  investidorDocumentType: InvestidorDocumentType;
}

export interface CadastroInvestidorRequest {
  cpfCnpj: string;
  razaoSocial: string;
  nacionalidade: string;
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  cidade: string;
  uf: string;
  profissaoAtividadePrincipal: string;
  email: string;
  telefones: Array<string>;
  investidorPoliticamenteExposto: boolean;
  dataNascimento?: Date;
  numero: string;
  tipo: TipoInvestidor;
  vinculadoCustodiante: boolean;
  representantesLegais: Array<RepresentanteLegalRequest>;
  rendaMensalDeclarada: number;
  patrimonioDeclarado: number;
  banco?: string;
  ispbBanco?: string;
  agencia?: string;
  agenciaDigito?: string;
  conta?: string;
  contaDigito?: string;
}

export interface InvestidorCertidaoResponse {
  ativo: boolean;
  investidorId: string;
  cpfCnpj: string;
  razaoSocial: string;
  bancoInvestidor: string;
}

export interface CertidaoTitularidadeRequest {
  dataReferencia: Moment;
  codigosInstrumentos: Array<string>;
}

export interface CertidaoInadimplenciaParams {
  emissorId: string | null;
  codigosInstrumentos: Array<string>;
}

export interface InvestidorResponse extends InvestidorInformacoesPrincipaisResponse {
  id: string;
  representantesLegais: Array<RepresentanteLegal>;
  documentos: Array<InvestidorDocuments>;
}

export interface InvestidorInformacoesPrincipaisResponse {
  suspenso: boolean;
  dataDeCriacao: Date;
  cpfCnpj: string;
  razaoSocial: string;
  contaDeposito: string;
  nacionalidade: string;
  dataNascimento: Moment;
  cep: string;
  logradouro: string;
  numero: string;
  complemento?: string;
  bairro: string;
  cidade: string;
  uf: string;
  profissaoAtividadePrincipal: string;
  cnaePrincipal: string;
  email: string;
  investidorPoliticamenteExposto: boolean;
  vinculadoCustodiante: boolean;
  tipo: TipoInvestidor;
  telefones: Array<string>;
  rendaMensalDeclarada: number;
  patrimonioDeclarado: number;
  ispbBanco: string;
  razaoSocialBanco: string;
  agenciaBanco: string;
  agenciaDigitoBanco: string;
  contaBanco: string;
  contaDigitoBanco: string;
  razaoSocialCustodiante: string;
  cnpjCustodiante: string;
}

export interface InvestidorDocumentResponse extends BaseDocumentResponse {
  investidorDocumentType: InvestidorDocumentType;
}

export interface EnderecoResponse {
  cep: string;
  logradouro: string;
  bairro: string;
  localidade: string;
  uf: string;
}

export interface GETInstrumentosFilterParams {
  registroStatus?: Array<RegistroStatus>;
  emissaoStatus?: Array<EmissaoStatus>;
  codigo?: string;
  origem?: string;
  aditado?: boolean;
  encerrado?: boolean;
  inadimplente?: boolean;
  page?: number;
  pageSize?: number;
  linkOperator?: string;
  isDetalheMovimentacaoIPO?: boolean;
  ticket?: string;
  instrumentosFinanceirosFilter?: Array<InstrumentosFinanceirosFilter>;
  tipoInstrumento?: Array<InstrumentoFinanceiro>;
  isTransferenciaCustodia?: boolean;
  emissorId?: string | null;
  custodianteId?: string | null;
  escrituradorId?: string | null;
  coordenadorId?: string | null;
}

export interface POSTEventosFinanceirosFilterParams {
  registroStatus?: Array<RegistroStatus>;
  emissaoStatus?: Array<EmissaoStatus>;
  codigo?: string;
  aditado?: boolean;
  encerrado?: boolean;
  inadimplente?: boolean;
  dataFrom?: Date | null;
  dataTo?: Date | null;
  page?: number;
  pageSize?: number;
  linkOperator?: string;
  eventosFinanceirosFilter?: Array<EventosFinanceirosFilter>;
  britech?: boolean;
}
export interface InstrumentosFinanceirosFilter {
  columnType?: string | number;
  operationFilterType?: string;
  orderByType?: string | number;
  value?: string;
}
export interface EventosFinanceirosFilter {
  columnType?: string;
  operationFilterType?: string;
  orderByType?: string;
  value?: string;
}
export interface InvestidoresFilter {
  columnType?: string;
  operationFilterType?: string;
  orderByType?: string;
  value?: string;
}

export interface BloqueiosFilter {
  columnType?: string;
  operationFilterType?: string;
  orderByType?: string;
  value?: string;
}
export interface GenericFilter {
  columnType?: string;
  operationFilterType?: string;
  orderByType?: string;
  value?: string;
}
export interface IPagination {
  result?: Array<any>;
  page: number;
  pageSize: number;
  totalCount?: number;
}

export interface IPaginatedDataPagination {
  page: number;
  pageSize: number;
  total: number;
}

export interface IPaginatedData<T> {
  data?: Array<T>;
  pagination: IPaginatedDataPagination;
}

export interface InstrumentoResumo {
  id: number;
  instrumentoFinanceiroGuid: string;
  codigo: string;
  tipoInstrumentoFinanceiro: InstrumentoFinanceiro;
  dataDeCriacao: Date;
  dataDeLiquidacao: Date;
  numeroEmissao: string;
  numeroSerie: string;
  quantidadeEmitida: number;
  quantidadeDepositada: number;
  quantidadeRestante: number;
  volumeEmissao: number;
  valorNominalUnitarioEmissao: number;
  percentualAmortizacaoRemanescente: number;
  precoUnitarioLiquidacao: number;
  puRemanescente: number;
  puAtualizado: number;
  encerrado?: boolean;
  statusEmissao: EmissaoStatus;
  razaoSocialEmissor: string;
  emails?: Array<string>;
  emissor?: ParticipanteResumo;
  investidoresPrivados?: Array<InvestidorResumoQuantidade>;
  distribuicaoPublica?: boolean;
  regimeFiduciario?: boolean;
}

export interface InvestidorResumoQuantidade extends InvestidorResumo {
  quantidade: {
    source: string;
    parsedValue: number;
  };
}

export interface ParticipanteResumo {
  id: string;
  razaoSocial: string;
  cnpj?: string;
}

export interface CancelamentoQuantidadesRequest {
  instrumentoFinanceiroId: string;
  custodianteId: string;
  investidorId: string;
  quantidade: number;
  justificativa: string;
}

export enum OperacaoTipo {
  OfertaPrimaria = 'OFERTA_PRIMARIA',
  CompraVenda = 'COMPRA_VENDA',
  Compra = 'COMPRA',
  Venda = 'VENDA',
  CompraVendaCompromissada = 'COMPRA_VENDA_COMPROMISSADA',
  CompraVendaCompromissadaRetorno = 'COMPRA_VENDA_COMPROMISSADA_RETORNO',
  TransferenciaInterop = 'TRANSFERENCIA_INTEROP',
  SaidaInteroperabilidade = 'SAIDA_INTEROPERABILIDADE',
  Transferencia = 'TRANSFERENCIA',
  TransferenciaTitularidade = 'TRANSFERENCIA_TITULARIDADE',
  TransferenciaCustodia = 'TRANSFERENCIA_CUSTODIA',
  TransferenciaUnificada = 'TRANSFERENCIA_UNIFICADA',
  CancelamentoQuantidades = 'CANCELAMENTO_QUANTIDADES',
}

export enum GrupoAcesso {
  Comum = 'PARTICIPANTE_COMUM',
  ControlesInternos = 'LAQUS_CONTROLES_INTERNOS',
  Operacoes = 'LAQUS_OPERACOES',
  CadastroLeitura = 'LAQUS_CADASTRO_LEITURA',
  OperacoesLeitura = 'LAQUS_OPERACOES_LEITURA',
  CadastroOperacoes = 'LAQUS_CADASTRO_OPERACOES',
  GestaoAcessos = 'LAQUS_GESTAO_ACESSOS',
}

export enum TipoNotificacaoEnum {
  EventoPrevistoPagamento = 'EVENTO_PREVISTO_PAGAMENTO',
}

export enum TipoDestinatariosEnum {
  TodosDaFuncao = 'TODOS_DA_FUNCAO',
  UsuariosSelecionados = 'USUARIOS_SELECIONADOS',
  EmailsEspecificos = 'EMAILS_ESPECIFICOS',
}

export interface NotificacaoConfiguracaoRequest {
  participanteFuncaoId: string;
  tipoNotificacao: TipoNotificacaoEnum;
  ativo: boolean;
  destinatarios: NotificacaoDestinatarioRequest[];
}

export interface AtualizarNotificacaoConfiguracaoRequest {
  ativo: boolean;
  destinatarios: NotificacaoDestinatarioRequest[];
}

export interface NotificacaoDestinatarioRequest {
  tipoDestinatario: TipoDestinatariosEnum;
  destinatarioId: string | null;
  email: string | null;
}

export interface NotificacaoConfiguracaoResponse {
  id: string;
  participanteFuncaoId: string;
  participanteFuncao: ParticipanteFuncaoInfo | null;
  tipoNotificacao: TipoNotificacaoEnum;
  tipoNotificacaoDescricao: string;
  dataCriacao: string;
  dataAlteracao: string;
  criadoPorId: string;
  criadoPorNome: string | null;
  alteradoPorId: string;
  alteradoPorNome: string | null;
  ativo: boolean;
  destinatarios: NotificacaoDestinatarioResponse[];
}

export interface NotificacaoDestinatarioResponse {
  id: string;
  tipoDestinatario: TipoDestinatariosEnum;
  tipoDestinatarioDescricao: string;
  destinatarioId: string | null;
  destinatarioNome: string | null;
  destinatarioEmail: string | null;
  email: string | null;
}

export interface ParticipanteFuncaoInfo {
  id: string;
  funcao: FuncaoParticipante | FuncaoInternaParticipante;
  participanteId: string;
  participanteRazaoSocial: string | null;
}

export enum OperacaoCommonStatus {
  EmAnalise = 'EM_ANALISE',
  Concluida = 'CONCLUIDA',
  Reprovada = 'REPROVADA',
}

export enum CompraVendaStatus {
  Cancelada = 'CANCELADA',
  AguardandoLiquidacao = 'AGUARDANDO_LIQUIDACAO',
  AguardandoAprovacaoADMFiduciario = 'AGUARDANDO_APROVACAO_ADM_FIDUCIARIO',
  AceiteOrigemRealizado = 'ACEITE_ORIGEM_REALIZADO',
  AceiteDestinoRealizado = 'ACEITE_DESTINO_REALIZADO',
  LiquidacaoEmProcessamento = 'LIQUIDACAO_EM_PROCESSAMENTO',
}

export enum OfertaPrimariaStatus {
  AguardandoConfirmacao = 'AGUARDANDO_CONFIRMACAO_CUSTODIANTE',
  Agendado = 'AGENDADO',
}

export type OperacaoStatus = OperacaoCommonStatus | CompraVendaStatus | OfertaPrimariaStatus;

export interface OperacaoOfertaPrimariaInvestidorRequest {
  investidorId: string;
  quantidade: number;
  precoUnitario: number;
}

export interface OperacaoOfertaPrimariaInformacoesBancariasRequest {
  razaoSocialBanco: string;
  agenciaBanco: string;
  contaBanco: string;
  ispbBanco: string;
}

export interface OperacaoOfertaPrimariaRequest {
  dataAgendamento?: Date | null;
  investidores: Array<OperacaoOfertaPrimariaInvestidorRequest>;
  informacoesBancarias: Array<OperacaoOfertaPrimariaInformacoesBancariasRequest>;
}

export interface OperacaoOfertaPrimariaCriarLiquidarRequest extends OperacaoOfertaPrimariaRequest {
  instrumentoFinanceiroGuid: string;
  solicitarLiquidacao: SolicitarLiquidacaoRequest;
}

export interface OfertaPrimariaInvestidorResponse {
  quantidade: number;
  precoUnitario: number;
  investidorId: string;
  razaoSocial: string;
  cpfCnpj: string;
  contaDeposito: string;
  comprovanteId?: string;
  comprovanteAddress?: string;
}

export interface OfertaPrimariaInformacoesBancariasResponse {
  razaoSocialBanco: string;
  agenciaBanco: string;
  contaBanco: string;
  ispbBanco: string;
}

export interface ApproveOfertaPrimariaRequest {
  tipoLiquidacao: TipoLiquidacao;
  custodianteId: string;
}

export interface OfertaPrimariaResponse {
  quantidadeTotal: number;
  investidores: Array<OfertaPrimariaInvestidorResponse>;
  informacoesBancarias?: Array<OfertaPrimariaInformacoesBancariasResponse>;
}

export interface BaseOperacaoResponse {
  id: string;
  dataDeCriacao: Date;
  tipo: OperacaoTipo;
  ticket: string;
  instrumentoFinanceiro: InstrumentoResumo;
  custodiante: ParticipanteResumo;
  status: OperacaoStatus;
  justificativa?: string;
}

export interface OperacaoOfertaPrimariaResponse extends BaseOperacaoResponse {
  ofertaPrimaria: OfertaPrimariaResponse;
  hasDocument?: boolean;
  nomeInvestidor?: string;
  quantidadeDisponivel?: number;
  puAtualizado?: number;
}

export interface OperacaoCompraVendaResponse extends BaseOperacaoResponse {
  participanteId: string;
  compraVenda: CompraVendaResponse;
  operacaoOrigemId?: string;
}

export interface CompraVendaResumoResponse {
  operacaoId: string;
  status: OperacaoStatus;
  dataCriacao: string;
  tipo: string;
  codigo: string;
  custodianteOrigem: string;
  custodianteDestino: string;
  investidorOrigem: string;
  investidorDestino: string;
  emissor: string;
  hasComprovantes?: boolean;
  participanteOrigemId?: string;
  isOperacaoPreviamenteRealizada: boolean;
  isCompra: boolean;
  nomeInvestidor?: string;
  quantidadeDisponivel?: number;
  puAtualizado?: number;
}

export interface CompraVendaDocumento {
  id: string;
  operacaoId: string;
  fileName: string;
  extension: string;
  size: number;
  creationDate: string;
  url: string;
}

export interface OperacaoCompraVendaCompromissadaResponse extends BaseOperacaoResponse {
  compraVenda: CompraVendaCompromissadaResponse;
  operacaoOrigemId?: string;
}

export interface InteroperabilidadeResponse {
  id: string;
  tipo: TipoInteroperabilidade;
  investidor: InvestidorResumo;
  quantidade: number;
  precoUnitario: number;
  statusAprovacao?: StatusInteroperabilidade;
  justificativa: string;
  documentos: Array<InteroperabilidadeDocumentoResponse>;
}

export interface InteroperabilidadeDocumentoResponse {
  interoperabilidadeId: string;
  documentId: string;
  address: string;
  fileName: string;
  extension: string;
  size: number;
  creationDate: string;
}

export enum StatusInteroperabilidade {
  Aprovado = 'APROVADO',
  Reprovado = 'REPROVADO',
  Pendente = 'PENDENTE',
}

export interface OperacaoInteroperabilidadeResponse extends BaseOperacaoResponse {
  interoperabilidade: InteroperabilidadeResponse;
}

export interface CompraVendaResponse {
  investidorOrigem: InvestidorResumo;
  quantidade: number;
  precoUnitario: number;
  investidorDestino: InvestidorResumo;
  liquidacaoDireta: boolean;
  aceiteOrigemParticipanteId?: string;
  aceiteDestinoParticipanteId?: string;
}

export interface CompraVendaCompromissadaResponse extends CompraVendaResponse {
  indexador: string;
  indexadorPorcentagem: number;
  taxaDeJuros: number;
  dataDeRetorno: Date;
  puDeRetorno: number;
}

export interface InvestidorResumo {
  id: string;
  cpfCnpj: string;
  razaoSocial: string;
  contaDeposito: string;
  participanteId: string;
  suspenso: boolean;
}

export interface GETOperacoesFilterParams {
  instrumentoFinanceiroId?: string;
  usuarioId?: string;
  participanteId?: string;
  investidorId?: string;
  page?: number;
  pageSize?: number;
  linkOperator?: string;
  ofertasPrimariasFilter?: Array<OfertasPrimariasFilter>;
}

export interface GETComprasVendasFilterParams {
  page?: number;
  pageSize?: number;
  linkOperator?: string;
  comprasVendasFilter?: Array<ComprasVendasFilter>;
}

export interface OfertasPrimariasFilter {
  columnType?: string;
  operationFilterType?: string;
  orderByType?: string;
  value?: string;
}

export enum TransferenciaStatus {
  AguardandoConfirmacao = 'AGUARDANDO_CONFIRMACAO',
  Concluida = 'CONCLUIDA',
  Cancelada = 'CANCELADA',
}

export interface ComprasVendasFilter {
  columnType?: string;
  operationFilterType?: string;
  orderByType?: string;
  value?: string;
}

export enum TransferenciaStatusEnum {
  Pendente = 'PENDENTE',
  Concluido = 'CONCLUIDO',
  Reprovado = 'REPROVADO',
}

export interface TransferenciaResumoResponse {
  id: string;
  dataDeCriacao: string;
  instrumentoFinanceiroCodigo: string;
  transferenciaTipo: string;
  custodianteOrigemRazaoSocial: string;
  custodianteOrigemCnpj: string;
  investidorOrigemCpfCnpj: string;
  custodianteDestinoRazaoSocial: string;
  custodianteDestinoCnpj: string;
  investidorDestinoCpfCnpj: string;
  quantidade: number;
  hasDocuments: boolean;
  status: string | null;
}

export interface TransferenciaResumoFilter {
  columnType?: string;
  operationFilterType?: string;
  orderByType?: string;
  value?: string;
}

export interface GETTransferenciasResumoFilterParams {
  page?: number;
  pageSize?: number;
  linkOperator?: string;
  transferenciaResumoFilter?: Array<TransferenciaResumoFilter>;
}

export interface GETConciliacaoCDFilterParams {
  page?: number;
  pageSize?: number;
  linkOperator?: string;
  conciliacaoContaDepositoFilter?: Array<ConciliacaoCDFilter>;
}

export interface ConciliacaoCDFilter {
  columnType?: string;
  operationFilterType?: string;
  orderByType?: string;
  value?: string;
}

export interface GETConciliacaoAtivoResponse {
  data: Moment;
  ultimaConciliacao?: Moment;
  realizado: boolean;
  instrumentoFinanceiroId: number;
  codigoInstrumentoFinanceiro: string;
  razaoSocialEmissorInstrumentoFinanceiro: string;
  quantidadeInstrumentoFinanceiro: number;
}

export interface GETConciliacoesContasDepositoResponse {
  realizado: boolean;
  custodiante: CustodianteResumo;
}

export interface CustodianteResumo {
  razaoSocial: string;
  cnpj: string;
}

export interface ContaDepositoResponse {
  instrumentoFinanceiroId: number;
  codigoInstrumentoFinanceiro: string;
  quantidadeInstrumentoFinanceiro: number;
  posicoes: Array<InstrumentoPosicaoResponse>;
}

export interface InstrumentoPosicaoResponse {
  investidor: InvestidorResponse;
  saldoDisponivel: number;
  saldoTotal: number;
  custodianteRazaoSocial: string;
  volumeFinanceiro?: number;
}

export interface GETInvestidorPosicoesRequest {
  instrumentoFinanceiroId?: string;
  emissorId?: string;
  escrituradorId?: string;
  custodianteId?: string;
  investidorId?: string;
}

export interface NovaSenhaRequestResponse {
  id: string;
}

export interface UsuarioMasterResponse {
  nome: string;
  email: string;
}

export enum PagamentoStatus {
  Previsto = 'PREVISTO',
  PendenteAprovacao = 'PENDENTE_APROVACAO',
  PendenteAprovacaoAgenteFiduciario = 'PENDENTE_APROVACAO_AF',
  Concluida = 'CONCLUIDA',
  AguardandoLiquidacao = 'AGUARDANDO_LIQUIDACAO',
  Reprovada = 'REPROVADA',
  ReprovadoAgenteFiduciario = 'REPROVADO_AF',
  Cancelada = 'CANCELADA',
  AguardandoComprovante = 'AGUARDANDO_COMPROVANTE',
  ParcialmenteConcluida = 'PARCIALMENTE_CONCLUIDA',
}

export enum EventoExtraordinarioTipo {
  Amortizacao = 'AMORTIZACAO_EXTRAORDINARIA',
  ResgateAntecipadoTotal = 'RESGATE_ANTECIPADO_TOTAL',
}

export enum PagamentoTipo {
  Amortizacao = 'AMORTIZACAO',
  Juros = 'JUROS',
  Mora = 'MORA',
  Multa = 'MULTA',
  Premio = 'PREMIO',
}

export interface PagamentoResponse {
  id: string;
  status: PagamentoStatus;
  tipo: PagamentoTipo | EventoExtraordinarioTipo;
  inadimplente: boolean;
  percentual?: number;
  dataVencimento: Date;
  dataPagamento?: Date;
  quantidade?: number;
  valorPagamento?: number;
  valorJuros?: number;
  valorMulta?: number;
  valorMora?: number;
  valorPremio?: number;
  liquidacaoDireta?: boolean;
  instrumentoFinanceiro: InstrumentoResumo;
  fechamentos: Array<Fechamento>;
  ultimoPagamento: boolean;
  DataCriacaoMovimentacao?: Date;
  hasDocuments?: boolean;
  blocked?: boolean;
  isMultiCustodiante?: boolean;
  liquidacaoAutomaticaBanco: boolean;
  puDiario?: number;
  puMulta?: number;
  puMora?: number;
  puAprovado?: boolean;
  tipoLiquidacaoInstrumento?: TipoLiquidacao;
  puProjetado?: number;
  historicoPUsProjetados?: Array<HistoricoPUProjetado>;
  motivoReprovacao?: string;
}

export enum HistoricoPUTipo {
  Laqus = 'LAQUS',
  Emissor = 'EMISSOR',
  AgenteFiduciario = 'AGENTE_FIDUCIARIO',
}

export interface HistoricoPUProjetado {
  id: string;
  tipo: HistoricoPUTipo;
  valor: number;
  dataCriacao: string;
  usuario?: string;
  participante?: string;
}

export interface PagamentoDocuments {
  id: number;
  address: string;
  fileName: string;
  extension: string;
  size: number;
  creationDate: Date;
  url: string;
}

export interface Fechamento {
  id: string;
  dataFechamento: Moment;
  tipo: PagamentoTipo;
  quantidade: number;
  precoUnitario: number;
  investidor: InvestidorResumo;
  custodiante: ParticipanteResumo;
}

export interface CalcularAmortizacaoRequest {
  instrumentoFinanceiroId?: string;
  valorUnitario?: number;
  percentual?: number;
  valorPagamento?: number;
  puRemanescente?: number;
}

export interface CalcularAmortizacaoResponse {
  percentual: number;
  valorPagamento: number;
  puRemanescenteApurado: number;
}

export interface PagamentoSolicitarLiquidacaoRequest {
  valorPagamento?: number;
  percentual?: number;
  valorMulta?: number;
  valorMora?: number;
  liquidacaoDireta: boolean;
  emails?: Array<string>;
}
export interface PagamentoSolicitarLiquidacaoEmLoteRequest {
  pagamentoId: string;
  valorPagamento?: number;
  percentual?: number;
  valorMulta?: number;
  valorMora?: number;
  liquidacaoDireta: boolean;
  anexos?: Array<File>;
  tipoPagamento: PagamentoTipo;
}

export interface PagamentoExtraordinarioRequest {
  tipo: EventoExtraordinarioTipo;
  liquidacaoDireta: boolean;
  percentual?: number;
  valorPagamento?: number;
  valorJuros?: number;
  valorPremio?: number;
}

export enum TipoLiquidacaoEvento {
  Direta = 'DIRETA',
  Bruta = 'BRUTA',
}

export interface OperacaoCompraVendaRequest {
  quantidade: number;
  precoUnitario: number;
  liquidacaoDireta: boolean;
  origem: {
    custodianteCnpj: string;
    cpfCnpjInvestidor: string;
    contaDepositoOrigem?: string;
  };
  destino: {
    custodianteCnpj: string;
    contaDepositoDestino: string;
    cpfCnpjInvestidorDestino?: string;
  };
}

export interface OrigemModel {
  CustodianteCnpj: string;
  CpfCnpjInvestidor: string;
  ContaDepositoOrigem: string;
}

export interface DestinoModel {
  CustodianteCnpj: string;
  ContaDepositoDestino: string;
}

export interface OperacaoCompraVendaCompromissadaRequest {
  Quantidade: number;
  OperacaoCodigo: string;
  PrecoUnitario: number;
  CustodianteDestinoId: string;
  ContaDepositoDestino: string;
  LiquidacaoDireta: boolean;
  Indexador: string | null;
  IndexadorPorcentagem: number;
  TaxaDeJuros: number;
  DataDeRetorno: string | null;
  PuDeRetorno: number;
  Origem: OrigemModel;
  Destino: DestinoModel;
}

export interface InvestidorResumo {
  id: string;
  cpfCnpj: string;
  razaoSocial: string;
  contaDeposito: string;
}

export interface PosicaoResponse {
  saldoDisponivel: number;
  saldoTotal: number;
  instrumentoFinanceiro: InstrumentoResumo;
  investidor: InvestidorResumo;
}

export interface InvestidorInstrumentoFinanceiroResponse {
  investidorId: string;
  instrumentoFinanceiroId: number;
  codigo: string;
  tipo: InstrumentoFinanceiro;
  razaoSocialEmissor: string;
  dataDaEmissao: Moment;
  valorDeEmissao: number;
  razoesSociaisCustodiantes: string;
}

export interface AddInteroperabilidadeRequest {
  tipo: TipoInteroperabilidade;
  instrumentoFinanceiroId: string;
  custodianteId: string;
  investidorId: string;
  precoUnitario: number;
  quantidade: number;
}

export interface TransferenciaInteroperabilidadeRequest {
  instrumentoFinanceiroId: number;
  custodianteId: string;
  investidorId: string;
  quantidade: number;
  precoUnitario: number;
  justificativa: string;
}

export enum TipoInteroperabilidade {
  Entrada = 'ENTRADA',
  Saida = 'SAIDA',
}

export enum BloqueioTipo {
  Garantia = 'GARANTIA',
  Constricao = 'CONSTRICAO',
}

export enum BloqueioDocumentType {
  Bloqueio = 'BLOQUEIO',
  Liberado = 'LIBERADO',
}

export enum ConstricaoTipo {
  Judicial = 'JUDICIAL',
  Administrativa = 'ADMINISTRATIVA',
}

export interface BloqueioDocumentResponse extends BaseDocumentResponse {
  tipo: BloqueioDocumentType;
}

export interface BloqueioResponse {
  id: string;
  dataDeCriacao: Date;
  tipo: BloqueioTipo;
  liberado: boolean;
  quantidade: number;
  instrumentoFinanceiro: InstrumentoResumo;
  justificativa?: string;
  investidorGarantidor: InvestidorResumo;
  dataDeLiberacao?: Date;
  justificativaLiberacao?: string;
  documentos?: Array<BloqueioDocumentResponse>;
  investidorGarantido?: InvestidorResumo;
  constricaoTipo?: ConstricaoTipo;
}

export interface DownloadResponse {
  url: string;
}

export interface BloqueioRequest {
  bloqueioTipo: BloqueioTipo;
  custodianteId: string;
  investidorId: string;
  instrumentoFinanceiroId: string;
  quantidade: number;
  justificativa: string;
  custodianteGarantidoId?: string;
  investidorGarantidoId?: string;
  constricaoTipo?: ConstricaoTipo;
}

export interface AdicionarBloqueioEmLoteRequest {
  codigos: string[];
  bloqueioTipo: BloqueioTipo;
  constricaoTipo?: ConstricaoTipo;
}

export interface BloqueioEmLoteInfo {
  razaoSocialCustodiante: string;
  cpfCnpjInvestidorGarantidor: string;
  contaDepositoGarantidor: string;
}

export interface ResponseBloqueioEmLote {
  codigo: string;
  sucesso: boolean;
  bloqueioResponse?: BloqueioEmLoteInfo;
  motivoFalha?: string;
}

export interface AdicionarExtratoRequest {
  NomeSolicitante: string;
  CpfCnpjSolicitante: string;
  NomeInvestidor: string;
  CpfCnpjInvestidor: string;
  DataInicio?: Moment | null | undefined;
  DataFim?: Moment | null | undefined;
}

export interface GetInvestidorInstrumentosParams {
  dataReferencia: string;
}

export interface ExtratoResponse {
  id: string;
  nomeSolicitante: string;
  cpfCnpjSolicitante: string;
  emailSolicitante: string;
  cpfCnpjGarantidor: string;
  ticket: string;
  fileName: string;
  creationDate: string;
  address: string;
  extension: string;
  size: number;
}

export interface GETInvestidoresParams {
  participanteId?: string;
  participanteCnpj?: string;
  cpfCnpj?: string;
}
export interface GETInvestidoresFilterParams {
  participanteId?: string;
  participanteCnpj?: string;
  cpfCnpj?: string;
  page?: number;
  pageSize?: number;
  linkOperator?: string;
  investidoresFilter?: Array<InvestidoresFilter>;
}

export interface GETBloqueiosFilterParams {
  page?: number;
  pageSize?: number;
  linkOperator?: string;
  bloqueiosFilter?: Array<BloqueiosFilter>;
  bloqueiosFilterType?: Array<BloqueiosFilter>;
}

export enum TransferenciaTipo {
  Custodia = 'CUSTODIA',
  Titularidade = 'TITULARIDADE',
}

export enum MotivoTransferencia {
  Doacao = 'DOACAO',
  Heranca = 'HERANCA',
  Pagamento = 'PAGAMENTO',
  Societario = 'SOCIETARIO',
  ExecucaoConstricaoGarantia = 'CONSTRICAO_GARANTIA',
  Outro = 'OUTRO',
}

export interface TransferenciaRequest {
  tipo: TransferenciaTipo;
  custodianteOrigemId: string;
  investidorOrigemId: string;
  custodianteDestinoId: string;
  investidorDestinoId: string;
  quantidade: number;
  motivo: MotivoTransferencia;
  justificativa: string;
}

export interface TransferenciaCustodiaRequest {
  instrumentoFinanceiroId: number;
  quantidade: number;
  custodianteOrigemId: string;
  investidorOrigemId: string;
  custodianteDestinoId: string;
  investidorDestinoId: string;
  justificativa: string;
}

export interface OperacaoTransferenciaResponse extends BaseOperacaoResponse {
  transferencia: TransferenciaResponse;
}

export interface TransferenciaResponse {
  id: string;
  tipo: TransferenciaTipo;
  custodianteOrigem: ParticipanteResumo;
  investidorOrigem: InvestidorResumo;
  custodianteDestino: ParticipanteResumo;
  investidorDestino: InvestidorResumo;
  quantidade: number;
  motivo: MotivoTransferencia;
  justificativa: string;
  anexos: Array<BaseDocumentResponse>;
}

export interface SolicitarLiquidacaoRequest {
  precoUnitario: number;
  tipoLiquidacao: TipoLiquidacao;
}

export interface TransferenciaCustodiaResponseData {
  transferenciaId: string;
  tipo: TransferenciaTipo;
  quantidade: number;
  dataDeCriacao: Moment;

  custodianteOrigemNome: string;
  custodianteOrigemCNPJ: string;
  custodianteOrigemId: string;

  investidorOrigemId: string;
  investidorOrigemNome: string;
  investidorOrigemCpfCnpj: string;

  custodianteDestinoNome: string;
  custodianteDestinoCNPJ: string;
  custodianteDestinoId: string;

  investidorDestinoId: string;
  investidorDestinoNome: string;
  investidorDestinoCpfCnpj: string;

  motivo: TransferenciaMotivo;
  justificativa: string;
  statusAprovacaoId: StatusTransferenciaCustodia;

  codigoInstrumento: string;
  instrumentoFinanceiroId: string;

  canApproveOrDisapprove: boolean;
  documents: Array<TransferenciaCustodiaDocument>;
}

export interface TransferenciaCustodiaDocument {
  id: string;
  address: string;
  fileName: string;
  extension: string;
  size: number;
  creationDate: Moment;
}

export interface TransferenciaCustodiaResponse {
  data: Array<TransferenciaCustodiaResponseData>;
  message: string;
}

export enum TipoInvestidor {
  Qualificado = 'QUALIFICADO',
  Profissional = 'PROFISSIONAL',
  Nenhum = 'NENHUM',
  Fundo = 'FUNDO',
}

export enum ConciliacaoStatus {
  AguardandoConciliacao = 'AGUARDANDO_CONCILIACAO',
  AguardandoDownload = 'AGUARDANDO_DOWNLOAD',
  Conciliado = 'CONCILIADO',
}

interface ConciliacaoResponse {
  conciliacaoContaDepositoId: string;
  custodiante: CustodianteResumo;
  realizado: boolean;
  data: Date;
  ultimaConciliacao?: Date;
  status: ConciliacaoStatus;
  atrasada: boolean;
}

export interface ConciliacaoArquivoResponse {
  conciliacaoInstrumentoFinanceiroArquivoId: string;
  atrasada: boolean;
  data: Date;
  participanteResponsavel: CustodianteResumo;
  possuiArquivo: boolean;
  status: ConciliacaoStatus;
}

export interface ConciliacaoContaDepositoResponse extends ConciliacaoResponse {
  possuiArquivo: boolean;
}

export interface ParticipanteAuthResponse {
  id: string;
  participanteFuncaoUsuarioId: string;
  codigo: string;
  dataCriacao: Date;
  tipoAcesso: TipoAcessoParticipante;
  funcao: FuncaoParticipante | FuncaoInternaParticipante;
  cnpj: string;
  razaoSocial: string;
  modulos: Array<ModuloUsuarioResponse>;
}

export enum Modulos {
  INSTRUMENTO_FINANCEIRO = 'INSTRUMENTO_FINANCEIRO',
  APROVACOES = 'APROVACOES',
  SOLICITACOES = 'SOLICITACOES',
  PARTICIPANTES = 'PARTICIPANTES',
  INVESTIDORES = 'INVESTIDORES',
  MOVIMENTACOES = 'MOVIMENTACOES',
  GESTAO_ACESSOS = 'GESTAO_ACESSOS',
  PARAMETRIZACOES = 'PARAMETRIZACOES',
  SOLICITACAO_CREDENCIAMENTO = 'SOLICITACAO_CREDENCIAMENTO',
  CERTIDOES = 'CERTIDOES',
  UPLOAD_ARQUIVOS = 'UPLOAD_ARQUIVOS',
  LIQUIDACOES = 'LIQUIDACOES',
  DELIMITACAO_LOTE = 'DELIMITACAO_LOTE',
  LANCAMENTO_PU = 'LANCAMENTO_PU',
  ATUALIZACAO_COTAS = 'ATUALIZACAO_COTAS',
}

export interface FuncaoModuloResponse {
  funcao: FuncaoParticipante | FuncaoInternaParticipante;
  modulos: Array<ModuloUsuarioResponse>;
}

export interface ModuloUsuarioResponse {
  id: number;
  nomeEnum: Modulos;
  nome: string;
  habilitado?: boolean;
}

export interface EventoFinanceiroCsv {
  tipo: string;
  data: string;
  percentual?: string;
}

export interface EventoFinanceiro {
  tipo: TipoEventoFinanceiro;
  data: Moment;
  percentual: number | null;
}

export enum TipoEventoFinanceiro {
  Amortizacao = 'A',
  PagamentoJuros = 'P',
  IncorporacaoJuros = 'I',
}

export enum TransferenciaMotivo {
  OUTRO = 0,
  DOACAO = 1,
  HERANCA = 2,
  PAGAMENTO = 3,
  SOCIETARIO = 4,
  CONSTRICAO_GARANTIA = 5,
}

export interface HistoricoResponse {
  usuarioId: string;
  usuarioNome: string;
  data: string;
  nomeDoCampo?: string;
  descricaoDoCampo?: string;
  descricaoDaAcao: string;
  valorAntigo?: string;
  valorNovo?: string;
}

export enum TipoAcessoParticipanteHistorico {
  Participante = 0,
  Credenciado = 1,
  Investidor = 2,
  Depositaria = 9,
}

export enum FuncaoParticipanteHistorico {
  Depositaria = 0,
  Emissor = 1,
  Custodiante = 2,
  Escriturador = 3,
  AgenteFiduciario = 4,
  BancoLiquidante = 5,
}

export interface DocumentParticipanteHistorico {
  Id: string;
  Address: string;
  FileName: string;
  Extension: string;
  Size: number;
  CreationDate: Date;
  Tipo: ParticipanteDocumentoTipoHistorico;
}

export enum ParticipanteDocumentoTipoHistorico {
  CartaoAssinaturas = 0,
  ContratoSocial = 1,
  ComprovanteEleicao = 2,
  DemonstracaoFinanceira = 3,
  TermoAdesaoParticipante = 4,
  ComprovantePoderSignatario = 5,
  AtoDeclaratorioCvm = 6,
  Procuracao = 7,
  Identidade = 8,
  Outros = 9,
}

export interface RepresentanteLegalHistorico {
  Id: string;
  Tipo: RepresentanteLegalTipoHistorico;
  Cpf: string;
  Nome: string;
}

export enum RepresentanteLegalTipoHistorico {
  Controlador = 0,
  Administrador = 1,
  Procurador = 2,
  RepresentanteLegal = 3,
}

export enum CargoTipoHistorico {
  C_Level = 0,
  Gerente = 1,
  Coordenador = 2,
  Analista = 3,
  SegurancaInformacao = 4,
  Juridico = 5,
  RepresentanteLegal = 6,
}

export interface DocumentHistorico {
  Id: string;
  Address: string;
  FileName: string;
  Extension: string;
  Size: number;
  CreationDate: Date;
  EmissionType: DocumentTypeHistorico;
}

export enum DocumentTypeHistorico {
  TermoSecuritizacao = 0,
  DeclaracaoInstituicaoCustodiante = 1,
  ComunicadoInicioDistribuicao = 2,
  DeclaracaoAgenteFiduciario = 3,
  ComprovacaoNaturezaJuridica = 4,
  OficioConcessaoRegistroOfertaPublica = 5,
  ProspectoPreliminarDefinitivo = 6,
  AvisosOfertaPublica = 7,
  EscrituraEmissao = 8,
  CartulaEmissão = 9,
}

export enum TipoSerieHistorico {
  Senior = 0,
  Subordinada = 1,
}

export enum NegociacaoSecundariaHistorico {
  Profissional = 0,
  Qualificado = 1,
  SemRestricao = 2,
}

export interface HistoricoTimeline {
  data: string;
  alteracoes: Array<DetalhesHistorico>;
}

export interface DetalhesHistorico<T = HistoricoParticipanteDetalhes | HistoricoDetalhes> {
  usuarioId: string;
  usuarioNome: string;
  data: Moment;
  nomeDoCampo: string;
  descricaoDoCampo: string;
  descricaoDaAcao: string;
  valorAntigo: T;
  valorNovo: T;
}

export type HistoricoParticipanteDetalhes = string | Array<DocumentParticipanteHistorico | RepresentanteLegalHistorico>;
export type HistoricoDetalhes = string | Array<DocumentHistorico | RepresentanteLegalHistorico>;

export interface BancosResponse {
  banks: Array<BancoResponse>;
}
export interface BancoResponse {
  ispb: string;
  cnpj: string;
  fullname: string;
  shortname: string;
  code: string;
}

export interface InvestidorVendaResponse {
  id: string;
  razaoSocial: string;
  cpfCnpj: string;
}

export interface EmissorInstrumentoResponse {
  codigo: string;
  numeroEmissao: string;
  quantidade: number;
  dataVencimento: string;
  serie: string;
}

export interface EmissorVendaResponse {
  razaoSocial: string;
  instrumentos: EmissorInstrumentoResponse[];
}

export interface CustodianteVendaResponse {
  id?: string;
  razaoSocial: string;
}

export interface InvestidorDestinoVendaResponse {
  razaoSocial: string;
}

export interface InvestidorCustodianteResponse {
  razaoSocial: string;
  cpfCnpj: string;
}

export interface CustodianteInvestidorResponse {
  razaoSocial: string;
  cnpj: string;
}

export type TransferenciaLoteStatus = 'SUCESSO' | 'PARCIAL' | 'FALHA';

export interface TransferenciaLoteResumo {
  totalProcessados: number;
  totalSucesso: number;
  totalPendente: number;
  totalConcluido: number;
  totalFalha: number;
}

export interface TransferenciaLoteItem {
  codigoIF: string;
  custodianteDestinoCnpj: string | null;
  investidorDestinoCpfCnpj: string | null;
  quantidade: number;
  operacaoId: string | null;
  sucesso: boolean;
  status: string | null;
  mensagemErro: string | null;
}

export interface TransferenciaLoteResponse {
  status: TransferenciaLoteStatus;
  mensagem: string;
  resumo: TransferenciaLoteResumo;
  itens: TransferenciaLoteItem[];
}

export interface TransferenciaCustodiaLoteRequest {
  investidorOrigemCpfCnpj: string;
  custodianteDestinoCnpj: string;
  instrumentosFinanceiros: Array<{
    codigo: string;
    quantidade: number;
  }>;
}

export interface TransferenciaTitularidadeLoteRequest {
  investidorOrigemCpfCnpj: string;
  instrumentosFinanceiros: Array<{
    codigo: string;
    destinos: Array<{
      custodianteDestinoCnpj: string | null;
      investidorDestinoCpfCnpj: string;
      quantidade: number;
    }>;
  }>;
}

export interface TransferenciaDocumentoLoteItem {
  operacaoId: string;
  sucesso: boolean;
  documento: {
    id: string;
    address: string;
    fileName: string;
    extension: string;
    size: number;
    creationDate: string;
    url: string;
  } | null;
  erro: {
    httpStatus: number;
    mensagem: string;
  } | null;
}

export interface TransferenciaDocumentoLoteResponse {
  status: TransferenciaLoteStatus;
  mensagem: string;
  resumo: {
    totalProcessados: number;
    totalSucesso: number;
    totalFalha: number;
  };
  itens: TransferenciaDocumentoLoteItem[];
}

export interface InvestidorInstrumentoVendaResponse {
  codigo: string;
  numeroEmissao: string;
  quantidade: number;
  dataVencimento: string;
  serie: string;
}

export interface VendaLoteOrigemRequest {
  custodianteCnpj: string;
  cpfCnpjInvestidor: string;
  codigoBanco: string;
}

export interface VendaLoteDestinoRequest {
  custodianteCnpj: string;
  cpfCnpjInvestidor: string;
  contaDepositoDestino: string;
  codigoBanco: string;
  quantidade: number;
  precoUnitario: number;
  liquidacaoDireta: boolean;
}

export interface VendaLoteItemRequest {
  operacaoCodigo: string;
  origem: VendaLoteOrigemRequest;
  destinos: VendaLoteDestinoRequest[];
}

export enum ContraparteRecebedoraEnum {
  COORDENADOR_LIDER = 'COORDENADOR_LIDER',
  BANCO_LIQUIDANTE_EMISSOR = 'BANCO_LIQUIDANTE_EMISSOR',
}

export enum StatusTransferenciaCustodia {
  Aprovado = 1,
  Reprovado = 10,
  Pendente = 20,
}

export interface CommandResult {
  errors: Array<string>;
  id: string;
  message: string;
  statusCode: number;
  success: boolean;
}

export interface CommandResultTyped<T> {
  errors: Array<string>;
  data: T;
  message: string;
  statusCode: number;
  success: boolean;
}

export interface FluxoMonitorResult {
  dataDeVencimento: Moment;
  amortizacao: number;
  juros: number;
  valorAquisicao: number;
  total: number;
  percentualAmortizacao: number;
}

export interface FluxoMonitor {
  id: string;
  data: Moment;
  principal: number;
  juros: number;
  valorAquisicao: number;
  valorParcela: number;
  percentualAmortizacao: number;
}

export interface SolicitacaoInteroperabilidadeResult {
  ticketId: string;
  interoperabilidadeId: string;
}

export interface Comprovante {
  id: string;
  investidorId: string;
  file?: File;
  remoteFileInfo?: BaseDocumentResponse;
}

export interface ComprovanteInvestidorResponse {
  id: string;
  address: string;
  fileName: string;
  extension: string;
  size: number;
  creationDate: string;
  url?: string;
}

export interface PaginatedResult<T> {
  result: Array<T>;
  page: number;
  pageSize: number;
  totalCount: number;
}

export interface RascunhoFilterResponse {
  filter: RascunhoFilter;
  rascunhos: Array<InstrumentoFinanceiroApiResponse>;
}

export interface RascunhoFilter {
  pageSize: number;
  haveMoreElements: boolean;
  page: number;
}

export interface CredenciadoEmissorRequest {
  cnpjEmissor: string;
  attachments: Array<CredenciadoDocumentRequest>;
}

export interface CredenciadoDocumentRequest {
  emissionType: string;
  file: File | undefined;
}

export interface AprovarOuReprovarCredenciamentoEmissorRequest {
  status: RegistroStatus;
  justificativa: string;
}

export interface AtivarDesativarParametrizacoesRequest {
  ativo: boolean;
  funcionalidadeId: number;
}

export interface RascunhoUpdateResponse {
  draftId: string;
  codigo: string;
}

export interface IAditamento {
  id: number;
  aditamentoGuid: string;
  codigoInstrumentoFinanceiro: string;
  aditamentoCount: number;
  instrumentoFinanceiroGuid: string;
  statusAditamentoId: AditamentoStatus;
  tipoInstrumentoFinanceiro: string;
  new: string;
  old: string;
  justificativa: string;
  nomeUsuario: string;
  emissorId: string;
  emissorRazaoSocial: string;
  dataDeCriacao: string;
  dataUltimaAlteracao: string;
  aditamentoDocumentId: number;
  aditamentoDocumentGuid: string;
}

export enum TipoPagamento {
  PagamentoFinal = 'PAGAMENTO_FINAL',
  TabelaSac = 'TABELA_SAC',
  TabelaPrice = 'TABELA_PRICE',
}

export enum ConvencaoCalendarioPagamento {
  ProximoDiaUtil = 'PROXIMO_DIA_UTIL',
  SemTratamento = 'SEM_TRATAMENTO',
}

export enum PeriodicidadeFluxoPagamento {
  Quinzenal = 'QUINZENAL',
  Mensal = 'MENSAL',
  Trimestral = 'TRIMESTRAL',
  Semestral = 'SEMESTRAL',
  Anual = 'ANUAL',
}

export interface IntegracaoMonitorResponse {
  tipoPagamento: TipoPagamento;
  convencaoCalendarioPagamento: ConvencaoCalendarioPagamento;
  periodicidadeAmortizacao: PeriodicidadeFluxoPagamento;
  primeiraParcelaAmortizacao: Moment;
  periodicidadeJuros: PeriodicidadeFluxoPagamento;
  primeiraParcelaJuros: Moment;
}

export interface KnowYourCustomerResponse {
  id: string;
  createdAt: Moment;
  resume: string;
  transaction: string;
}

export enum TipoRegistroInstrumentoFinanceiro {
  Cadastro,
  Edicao,
  EdicaoEmitido,
  Aditamento,
}

export enum GarantiaTipoEnum {
  SEM_GARANTIA = 1,
  FIDEJUSSORIA = 2,
  GARANTIA_REAL = 3,
}

export enum GarantiaSubTipoEnum {
  COM_COOBRIGACAO = 1,
  SEM_COOBRIGACAO = 2,
  AVAL = 3,
  FIANCA = 4,
  DIREITOS_CREDITORIOS = 5,
  RECEBIVEIS_CARTAO_CREDITO = 6,
  TITULOS_CREDITO = 7,
  VEICULOS = 8,
  IMOVEL = 9,
  SAFRA = 10,
  ESTOQUE = 11,
  INVESTIMENTOS = 12,
  MAQUINARIO = 13,
  EMBARCACAO = 14,
  AERONAVE = 15,
  OUTROS = 16,
}
export enum TipoCertidao {
  CertidaoTitularidade = 'CERTIDAO_TITULARIDADE',
  TermoEncerramento = 'TERMO_ENCERRAMENTO',
  ExtratoMovimentacoes = 'EXTRATO_MOVIMENTACOES',
  Gravame = 'Gravame',
  CertidaoInadimplencia = 'CERTIDAO_INADIMPLENCIA',
}

export enum TipoDocumentoS3 {
  RegistrodeNC = 'RegistrodeNC',
  LancamentoOP = 'LancamentoOP',
  CadastroLote = 'CadastroLote',
  CadastroFundosLote = 'CadastroFundosLote',
}

export interface postNotaComercialByFileResponse {
  diretorio: string;
  nomeArquivo: string;
}

export interface postFundosInvestidoresLoteByFileResponse {
  diretorio: string;
  nomeArquivo: string;
}

export interface getNotaComercialByFileResponse {
  dataModificacao: Date;
  diretorio: string;
  nomeArquivo: string;
  bucketName: string;
}

export interface getFileByNotaComercialResponse {
  arquivo: string;
}

export interface FileResponse {
  id?: number;
  razaoCustodiante?: string;
  nomeArquivo?: string;
  dataResponse?: Date;
  tipoArquivo?: string;
  fileResponse?: string;
}

export interface ReservarUltimoNumeroDaEmissaoRequest {
  emissorCnpj: string;
  tipoInstrumento: InstrumentoFinanceiro;
  externalId: string;
  numeroProximaEmissao: string;
}
export interface InvestidorFileResponse {
  razaoSocialInvestidor?: string;
  cpfCnpjInvestidor?: string;
  valido: boolean;
  data: InvestidorFile;
}

export interface InvestidorFile {
  'CPF CNPJ': string;
  'Razão Social': string;
  Email: string;
  Nacionalidade: string;
  Telefones: string;
  'Politicamente Exposto': string;
  'Data Nascimento': Date;
  'Renda Mensal Declarada': string;
  'Patrimonio Declarado': string;
  'Atividade Principal / Profissão': string;
  'CNPJ Custodiante': string;
  CEP: string;
  Logradouro: string;
  Complemento: string;
  Bairro: string;
  Cidade: string;
  UF: string;
  Numero: string;
}

export enum InstrumentoEdicaoStatus {
  AGUARDANDO_APROVACAO = 'AGUARDANDO_APROVACAO',
  APROVADO = 'APROVADO',
  REPROVADO = 'REPROVADO',
}

export interface InstrumentoEdicaoResponse {
  id: string;
  instrumentoFinanceiroId: string;
  instrumentoFinanceiroCodigo: string;
  tipo: InstrumentoFinanceiro;
  oldInstrumento: string;
  newInstrumento: string;
  usuarioId: string;
  usuarioEmail: string;
  status: InstrumentoEdicaoStatus;
  dataAlteracao: Date;
  dataCriacao: Date;
}

export interface Coordenador {
  coordenadorId: string;
  limite: number;
  cnpj: string;
  razaoSocial: string;
}

export interface DistribuirLoteRequest {
  coordenadores: Array<Coordenador>;
  tipoDelimitacao: 'VALOR' | 'QUANTIDADE';
}

export interface PostInstrumentosCoordenadoresRequest {
  coordenadorId: string;
  codigo?: string;
  emissorId?: string;
  page: number;
  pageSize: number;
}

export interface AtualizarCoordenadoresRequest {
  coordenadores: Array<{ coordenadorId: string }>;
  coordenadorLiderId?: string;
}

export interface DelimitacaoCoordenadorResponse {
  instrumentoFinanceiroId: number;
  coordenadorId: string;
  tipoDelimitacao: 'VALOR' | 'QUANTIDADE';
  valor: number;
  isCoordenadorLider: boolean;
}

export interface CancelarAlterarAgendamentoRequest {
  operacaoId: string;
  data: string | null;
  action: AgendamentoHandleAction;
}

export enum AgendamentoHandleAction {
  CANCELAR = 'CANCELAR',
  ALTERAR = 'ALTERAR',
}

export enum StatusAgendamento {
  AGENDADO = 'AGENDADO',
  PROCESSANDO = 'PROCESSANDO',
  CANCELADO = 'CANCELADO',
  REALIZADO = 'REALIZADO',
}

export interface AgendamentoMovimentacao {
  id: string;
  instrumentoFinanceiroId: number;
  operacaoId: string;
  tipoMovimentacao: OperacaoTipo;
  dataAgendamento: string;
  status: StatusAgendamento;
  agendadoPor: string;
  dataCriacao: string;
  dataAtualizacao: string;
  instrumentoFinanceiro?: InstrumentoFinanceiroApiResponse;
  operacao?: any;
}

export enum Periodicidade {
  Diario = 0,
  Mensal = 1,
  Anual = 2,
}

export interface EventosFinanceiros {
  datasPagamentoJuros?: Moment[];
  percentualAmortizacaoPassivelAlteracao?: boolean;
  percentualAmortizacaoSobre: AmortizacaoSobre;
  amortizacoes: Amortizacao[];
  datasIncorporacaoJuros?: Moment[];
  resgateAntecipadoFacultativo: boolean;
  modalidadeAmortizacao?: ModalidadeAmortizacao;
}
